import { ProductDto } from '../../app/@api';

export const MOCK_PRODUCTS: ProductDto[] = [
    {
        "id": 8,
        "uid": "3b8c32f4-f166-11ee-be92-4e2528fc3ca0",
        "code": "CS6W-545MS-T",
        "name": "144 cell 545W Mono Solar Panel",
        "longName": "Canadian Solar 144 cell 545W Monocrystalline (Module HiKu) Solar Panel",
        "brand": "Canadian Solar",
        "image": "https://www.solarcentral.co.za/images/CS6W-545MS-T.png",
        "price": 0,
        "category": "PV Panels",
        "subCategory": "Monocrystalline",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Canadian Solar 545W Polycrystalline Solar Panel",
        "keywords": "Canadian Solar, 545W, Monocrystalline, Solar, Panel, PV, Mono",
        "description": "Canadian Solar 144 cell 545W Monocrystalline (Module HiKu) Solar Panel",
        "root": "canadian-solar-545w-mono",
        "visible": true,
        "highlights": [
            {
                "id": 268,
                "label": "Type",
                "value": "Monocrystalline"
            },
            {
                "id": 269,
                "label": "Power",
                "value": "545W"
            },
            {
                "id": 267,
                "label": "Device",
                "value": "Solar Panel"
            }
        ],
        "overviews": [
            {
                "id": 80,
                "html": "The Canadian Solar 545W photovoltaic (PV) panel is a high-efficiency solar panel designed to generate electricity from sunlight. With a power output of 545 watts, it is capable of producing significant amounts of energy, making it suitable for residential, commercial, and utility-scale solar installations.&#160;<div><br></div><div>This panel utilises advanced solar cell technology to maximise efficiency and performance, ensuring optimal power production even in low-light conditions. Designed with durability in mind, it features a robust frame and high-quality materials to withstand harsh weather conditions and ensure long-term reliability.&#160;</div><div><br></div><div>The Canadian Solar 545W panel offers an environmentally friendly and sustainable energy solution for powering homes, businesses, and communities with clean, renewable solar energy.</div>"
            }
        ],
        "specifications": [
            {
                "id": 780,
                "label": "Output Current",
                "value": "13.14A"
            },
            {
                "id": 783,
                "label": "Open Circuit Voltage",
                "value": "49.4V"
            },
            {
                "id": 776,
                "label": "Device",
                "value": "Solar Panel"
            },
            {
                "id": 781,
                "label": "Size",
                "value": "2261 x 1134 x 35 (mm)"
            },
            {
                "id": 777,
                "label": "Type",
                "value": "Monocrystalline"
            },
            {
                "id": 784,
                "label": "Short Circuit Current",
                "value": "13.95A"
            },
            {
                "id": 778,
                "label": "Power Output",
                "value": "545W"
            },
            {
                "id": 782,
                "label": "Weight",
                "value": "27.8kg"
            },
            {
                "id": 779,
                "label": "Input Voltage",
                "value": "41.5V"
            }
        ],
        "documents": [
            {
                "id": 116,
                "description": "Datasheet - Solar Panel Canadian 545W",
                "url": "https://www.solarcentral.co.za/pdf/CS6W-545MS-T.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 76,
                "distributor": "Herholdts",
                "distributorClient": "za.co.visualage.inventory.distributor.HerholdtsDistributorClient",
                "refreshUrl": "https://herholdts.co.za/pi64740/canadian-solar-144-cell-545w-t6-connector-shp-mono-perc-module-hiku/",
                "code": "CS6W-545MS-T",
                "sku": "CS6W-545MS-T",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.14,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 86,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 87,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 85,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 88,
                "type": "Ease of Use",
                "rating": 4
            }
        ]
    },
    {
        "id": 79,
        "uid": "c972a84a-bc69-4d93-86a4-e4f78c384f11",
        "code": "JA-M72S20-545-MR",
        "name": "545W Mono Solar Panel",
        "longName": "JA Solar 545W Mono (JA-M72S20-545-MR)",
        "brand": "JA Solar",
        "image": "https://www.solarcentral.co.za/images/JA-M72S20-545-MR.png",
        "price": 2300,
        "category": "PV Panels",
        "subCategory": "Monocrystalline",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | JA Solar 545W Mono",
        "keywords": "solar storage, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, JA, Solar, 545W, Mono, JA Solar",
        "description": "The JA Solar 545W Mono Solar Panel is a cutting-edge photovoltaic module that offers exceptional performance and efficiency, designed to harness the power of sunlight and convert it into clean, renewable energy. Built by JA Solar, a renowned global manufacturer of high-quality solar products, this panel represents the latest advancements in solar technology.",
        "root": "ja-solar-545w-mono",
        "visible": true,
        "highlights": [
            {
                "id": 182,
                "label": "Warranty",
                "value": "12 Years"
            },
            {
                "id": 180,
                "label": "Panel Efficiency",
                "value": "21.1%"
            },
            {
                "id": 179,
                "label": "Maximum Power (Pmax/W)",
                "value": "545W"
            },
            {
                "id": 181,
                "label": "Weight",
                "value": "28.1kg"
            }
        ],
        "overviews": [
            {
                "id": 47,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The JA Solar 545W Mono Solar Panel is a cutting-edge photovoltaic module that offers exceptional performance and efficiency, designed to harness the power of sunlight and convert it into clean, renewable energy. Built by JA Solar, a renowned global manufacturer of high-quality solar products, this panel represents the latest advancements in solar technology.</div><div><br></div><h4>Key Features:</h4><div><br></div><div>High Power Output:&#160;</div><div>With a power rating of 545 watts, this mono-crystalline solar panel delivers impressive power generation, making it suitable for various residential, commercial, and utility-scale applications. Its high output ensures maximum energy production even in limited roof space.</div><div><br></div><div>Mono-crystalline Solar Cells:&#160;</div><div>The panel features highly efficient mono-crystalline solar cells that offer superior light absorption and conversion rates. These cells are made from a single crystal structure, enabling them to convert sunlight into electricity with minimal energy loss. The use of mono-crystalline cells enhances the overall efficiency of the panel.</div><div><br></div><div>Advanced PERC Technology:&#160;</div><div>The JA Solar 545W Mono Solar Panel incorporates Passivated Emitter Rear Contact (PERC) technology, which optimises the cell's performance by reducing electron recombination. This technology increases the module's efficiency, allowing it to generate more power from the same amount of sunlight.</div><div><br></div><div>Durable and Weather Resistant:&#160;</div><div>The panel is constructed with high-quality materials and is built to withstand various weather conditions. It is designed to resist corrosion, humidity, and extreme temperatures, ensuring long-lasting performance and durability.</div><div><br></div><div>Enhanced Low-Light Performance:&#160;</div><div>The JA Solar 545W Mono Solar Panel exhibits excellent low-light performance, enabling it to generate electricity even under cloudy or shaded conditions. This feature ensures consistent energy production throughout the day, maximising overall system efficiency.</div><div><br></div><div>Easy Installation: T</div><div>he panel is lightweight and compact, making it easy to handle and install. It comes with pre-drilled holes and mounting accessories, simplifying the installation process for both rooftop and ground-mounted systems.</div><div><br></div><div>Certified and Reliable:&#160;</div><div>JA Solar is a well-established brand known for its commitment to quality and reliability. The 545W Mono Solar Panel is manufactured according to stringent industry standards and has obtained various certifications, such as IEC, UL, and TUV, ensuring its safety, performance, and compliance.</div><div><br></div><div>Aesthetically Pleasing Design:&#160;</div><div>The panel features a sleek and elegant design, blending seamlessly into various architectural styles. Its uniform black appearance enhances the visual appeal of the installation, making it an attractive choice for residential and commercial applications.</div><div><br></div><div>Overall, the JA Solar 545W Mono Solar Panel is a high-performance solar module that offers exceptional power output, efficiency, and durability. With its advanced technology and reliable construction, it provides a reliable and sustainable solution for harnessing solar energy and reducing carbon footprint. Whether for residential, commercial, or utility-scale projects, this panel is a top choice for those seeking to maximise their solar energy production.</div></div>"
            }
        ],
        "specifications": [
            {
                "id": 712,
                "label": "Efficiency",
                "value": "21.1%"
            },
            {
                "id": 711,
                "label": "Cell Type",
                "value": "Mono"
            },
            {
                "id": 713,
                "label": "Weight",
                "value": "28.1Kg"
            },
            {
                "id": 710,
                "label": "Power Output",
                "value": "545W"
            },
            {
                "id": 715,
                "label": "Warranty",
                "value": "12 Years"
            },
            {
                "id": 714,
                "label": "Dimensions",
                "value": "228 × 3.5 × 114cm"
            }
        ],
        "documents": [
            {
                "id": 109,
                "description": "JA Solar JAM72S20 545MR 530 555 Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/JA-Solar-JAM72S20-545MR-530-555-Datasheet.pdf"
            },
            {
                "id": 111,
                "description": "JA Solar Installation Manual",
                "url": "https://www.solarcentral.co.za/pdf/JA-Solar-Installation-Manual.pdf"
            },
            {
                "id": 110,
                "description": "JA Solar Warranty",
                "url": "https://www.solarcentral.co.za/pdf/JA-Solar-Warranty.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 45,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/product-30/",
                "code": "JA-M72S20-545-MR",
                "sku": "JAM72S20-545/MR",
                "inventoryStatus": "INSTOCK",
                "cost": 2123.73,
                "markup": 0.083,
                "retail": 2300
            }
        ],
        "ratings": [
            {
                "id": 82,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 83,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 84,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 81,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 13,
        "uid": "1d0b5988-026c-11ef-9149-4e2528fc3ca0",
        "code": "SC-ELV-002-3",
        "name": "Adjust Roof Rail Clamp",
        "longName": "Adjust Roof Rail Clamp (30 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-002-3.png",
        "price": 35,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps & Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline",
        "description": "Adjust Roof Rail Clamp (30 sets per Box)",
        "root": "adjust-roof-rail-clamp",
        "visible": true,
        "highlights": [
            {
                "id": 290,
                "label": "Type",
                "value": "Adjustable Height Bracket"
            },
            {
                "id": 289,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 85,
                "html": "<span><font color=\"#2d2d2d\" face=\"Arial\"><div>You may raise and level the rail on the roof with the help of an adjustable bracket that holds the Ali Rail to the roof.&#160;</div><div>Uses for the adjustable roof rail bracket include:</div><div><br></div><div><ul><li><span>Mounts the Ali Rail to the Roof.</span><br></li><li><span>Mounts the Ali Rail to the Klip Lock Bracket.<br></span></li><li><span>Mounts the Ali Rail to the Tile Roof Bracket.</span></li></ul></div><h3><b><u>Features</u></b></h3><div><br></div><div>High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; also includes a Stitching Screw (12&#215;20 with seal), which is frequently used on any common surface. Include an M6 Stainless Steel Bolt and Nut.</div><div><br></div><div>No additional waterproofing required as the bracket come supplied with a full-size waterproof rubber pad adhesive to the bracket under surface.</div><div><br></div><h3><u><b>What&#8217;s in a set?</b></u></h3><div><br></div><div><ul><li>1 x El-Vic Adjustable Bottom Clamp</li><li>2 x El-Vic Adjustable Top Clamp<br></li><li>1 x M6 Stainless Steel Bolt and Nut<br></li><li>1 x Rubber Sealant Tape<br></li><li>1 x Hex Top Speed (14&#215;25)</li></ul></div></font></span>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 18,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-05.png"
            },
            {
                "id": 15,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-02.png"
            },
            {
                "id": 25,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-12.png"
            },
            {
                "id": 21,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-08.png"
            },
            {
                "id": 20,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-07.png"
            },
            {
                "id": 16,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-03.png"
            },
            {
                "id": 17,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-04.png"
            },
            {
                "id": 24,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-11.png"
            },
            {
                "id": 22,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-09.png"
            },
            {
                "id": 14,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-01.png"
            },
            {
                "id": 26,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-13.png"
            },
            {
                "id": 19,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-06.png"
            },
            {
                "id": 23,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-10.png"
            },
            {
                "id": 27,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3-14.png"
            },
            {
                "id": 13,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-002-3.png"
            }
        ],
        "distributors": [
            {
                "id": 82,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/adjust-roof-rail-clamp/",
                "code": "SC-ELV-002-3",
                "sku": "Elvic 002-3",
                "inventoryStatus": "INSTOCK",
                "cost": 32.41,
                "markup": 0.08,
                "retail": 35
            }
        ],
        "ratings": [
            {
                "id": 128,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 111,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 155,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 145,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 11,
        "uid": "119806fe-fee9-11ee-8822-4e2528fc3ca0",
        "code": "SC-ELV-001-250",
        "name": "Ali Rail Short – 250mm",
        "longName": "Ali Rail Short – 250mm (25 sets per box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-001-250.png",
        "price": 62,
        "category": "Mounting Structures",
        "subCategory": "Profiles",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures",
        "keywords": "Elvic, Profiles, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline",
        "description": "Ali Rail Short – 250mm (25 sets per box)",
        "root": "ali-rail-short-250mm-25-sets-per-box",
        "visible": true,
        "highlights": [
            {
                "id": 285,
                "label": "Type",
                "value": "Mounting Bracket"
            },
            {
                "id": 286,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 83,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">Roof Mount Short Rail Adjustable Solar Panel Mounting Bracket. Easy to transport, and easy to Install</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\"><span>High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with four Stitching Screws (12&#215;20 with seal), which are often used on any regular surface.</span><font color=\"#2d2d2d\"><br></font></font></div><div><span><font face=\"Arial\"><br></font></span></div><div><p><font face=\"Arial\">No additional waterproofing required as the bracket come supplied with a full-size waterproof rubber pad adhesive to the bracket under surface.</font></p><p><font face=\"Arial\">We provide two length options (250mm &amp; 350mm)</font></p><p><font face=\"Arial\">25 Sets per box</font></p><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><br></font></u></span></div><div><ul><li><font face=\"Arial\"><span>1 x 250mm El-Vic Aluminium Rail</span><br><span>4 x Stitching Screws</span><br><span>1 x 250mm Rubber Sealant Tape</span><br></font></li></ul></div><div><span><br></span></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 3,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-250-02.png"
            },
            {
                "id": 1,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-250.png"
            },
            {
                "id": 5,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-250-04.png"
            },
            {
                "id": 2,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-250-01.png"
            },
            {
                "id": 4,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-250-03.png"
            },
            {
                "id": 6,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-250-05.png"
            }
        ],
        "distributors": [
            {
                "id": 79,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/ali-rail-short-250mm-25-sets-per-box/",
                "code": "SC-ELV-001-250",
                "sku": "Elvic 001-250",
                "inventoryStatus": "INSTOCK",
                "cost": 57.41,
                "markup": 0.08,
                "retail": 62
            }
        ],
        "ratings": [
            {
                "id": 124,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 135,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 112,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 136,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 12,
        "uid": "082484fe-01a9-11ef-a8b9-4e2528fc3ca0",
        "code": "SC-ELV-001-350",
        "name": "Ali Rail Short – 350mm",
        "longName": "Ali Rail Short – 350mm (25 sets per box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-001-350.png",
        "price": 83,
        "category": "Mounting Structures",
        "subCategory": "Profiles",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 5,
        "reviews": 1,
        "title": "Solar Central | Products | PV Panel Mounting Structures",
        "keywords": "Elvic, Profiles, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline",
        "description": "Ali Rail Short – 350mm (25 sets per box)",
        "root": "ali-rail-short-350mm-25-sets-per-box",
        "visible": true,
        "highlights": [
            {
                "id": 287,
                "label": "Installation Difficulty",
                "value": "Easy"
            },
            {
                "id": 288,
                "label": "Type",
                "value": "Mounting Bracket"
            }
        ],
        "overviews": [
            {
                "id": 84,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">Roof Mount Short Rail Adjustable Solar Panel Mounting Bracket. Easy to transport, and easy to Install</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\"><span>High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with four Stitching Screws (12&#215;20 with seal), which are often used on any regular surface.</span><font color=\"#2d2d2d\"><br></font></font></div><div><span><font face=\"Arial\"><br></font></span></div><div><p><font face=\"Arial\">No additional waterproofing required as the bracket come supplied with a full-size waterproof rubber pad adhesive to the bracket under surface.</font></p><p><font face=\"Arial\">We provide two length options (250mm &amp; 350mm)</font></p><p><font face=\"Arial\">25 Sets per box</font></p><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><br></font></u></span></div><div><ul><li><font face=\"Arial\"><span>1 x 250mm El-Vic Aluminium Rail</span><br><span>4 x Stitching Screws</span><br><span>1 x 250mm Rubber Sealant Tape</span><br></font></li></ul></div><div><span><br></span></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 8,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-350-01.png"
            },
            {
                "id": 7,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-350.png"
            },
            {
                "id": 9,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-350-02.png"
            },
            {
                "id": 11,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-350-04.png"
            },
            {
                "id": 10,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-350-03.png"
            },
            {
                "id": 12,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-001-350-05.png"
            }
        ],
        "distributors": [
            {
                "id": 81,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/ali-rail-short-350mm-25-sets-per-box/",
                "code": "SC-ELV-001-350",
                "sku": "Elvic 001-350",
                "inventoryStatus": "INSTOCK",
                "cost": 76.85,
                "markup": 0.08,
                "retail": 83
            }
        ],
        "ratings": [
            {
                "id": 118,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 95,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 97,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 127,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 15,
        "uid": "bea63aba-08b1-11ef-be4e-4e2528fc3ca0",
        "code": "SC-ELV-004",
        "name": "Ali Rail – 4.4m",
        "longName": "Ali Rail – 4.4m (Bulk 6/12 Rails)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-004.png",
        "price": 0,
        "category": "Mounting Structures",
        "subCategory": "Profiles",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Profiles",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Aluminum Rail, Solar",
        "description": "Ali Rail – 4.4m (Bulk 6/12 Rails)",
        "root": "ali-rail-4-4m-bulk-12-rails",
        "visible": true,
        "highlights": [
            {
                "id": 294,
                "label": "Type",
                "value": "Aluminum Rail"
            },
            {
                "id": 293,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 87,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">A solar panel roof mounting option appropriate for the majority of pitched or flat roof types is Ali Rail &#8211; 4.4m. Each one measures 4400mm in length, and they can be joined using the Jointer Kit to extend the Rail to the desired length. The rail may be simply transported on any LDV at 4.4 meters.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance. Up to 9-meter rails can be ordered (special order terms and conditions apply).</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><br></font></u></span></div><div><ul><li><font face=\"Arial\">Bulk (6 or 12) x 4.4 meter Elvic Aluminium Rails</font></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 37,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-04.png"
            },
            {
                "id": 41,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-08.png"
            },
            {
                "id": 33,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004.png"
            },
            {
                "id": 35,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-02.png"
            },
            {
                "id": 39,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-06.png"
            },
            {
                "id": 36,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-03.png"
            },
            {
                "id": 38,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-05.png"
            },
            {
                "id": 40,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-07.png"
            },
            {
                "id": 34,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-01.png"
            }
        ],
        "distributors": [
            {
                "id": 84,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/ali-rail-4-4m-bulk-12-rails/",
                "code": "SC-ELV-004",
                "sku": "Elvic 004",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.25,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 103,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 149,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 92,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 93,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 16,
        "uid": "86227f6e-08b6-11ef-857a-4e2528fc3ca0",
        "code": "SC-ELV-004-4.8",
        "name": "Ali Rail – 4.8m",
        "longName": "Ali Rail – 4.8m (Bulk 6/12 Rails)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8.png",
        "price": 527,
        "category": "Mounting Structures",
        "subCategory": "Profiles",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Profiles",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum",
        "description": "Ali Rail – 4.8m (Bulk 6/12 Rails)",
        "root": "ali-rail-4-8m-bulk-12-rails",
        "visible": true,
        "highlights": [
            {
                "id": 297,
                "label": "Type",
                "value": "Aluminum Rail"
            },
            {
                "id": 296,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 88,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">A solar panel roof mounting option appropriate for the majority of pitched or flat roof types is Ali Rail &#8211; 4.8m. Each one measures 4800mm in length, and they can be joined using the Jointer Kit to extend the Rail to the desired length. The rail may be simply transported on any LDV at 4.8 meters.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance. Up to 9-meter rails can be ordered (special order terms and conditions apply).</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><br></font></u></span></div><div><ul><li><font face=\"Arial\">Bulk (6/12) x 4.8 meter Elvic Aluminium Rails<br></font></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 50,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-08.png"
            },
            {
                "id": 46,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-04.png"
            },
            {
                "id": 48,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-06.png"
            },
            {
                "id": 44,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-02.png"
            },
            {
                "id": 42,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8.png"
            },
            {
                "id": 47,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-05.png"
            },
            {
                "id": 49,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-07.png"
            },
            {
                "id": 43,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-01.png"
            },
            {
                "id": 45,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-004-4.8-03.png"
            }
        ],
        "distributors": [
            {
                "id": 85,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/ali-rail-4-8m-bulk-12-rails/",
                "code": "SC-ELV-004-4.8",
                "sku": "Elvic 004-4.8-P12",
                "inventoryStatus": "INSTOCK",
                "cost": 421.6,
                "markup": 0.25,
                "retail": 527
            }
        ],
        "ratings": [
            {
                "id": 139,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 108,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 119,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 141,
                "type": "Ease of Use",
                "rating": 4
            }
        ]
    },
    {
        "id": 17,
        "uid": "173aebe6-093c-11ef-88d2-4e2528fc3ca0",
        "code": "SC-ELV-005",
        "name": "Ali Rail – L-Bracket",
        "longName": "Ali Rail – L-Bracket (80 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-005.png",
        "price": 15,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum",
        "description": "Ali Rail – L-Bracket (80 sets per Box)",
        "root": "ali-rail-l-bracket",
        "visible": true,
        "highlights": [
            {
                "id": 298,
                "label": "Installation Difficulty",
                "value": "Easy"
            },
            {
                "id": 299,
                "label": "Type",
                "value": "Fixed Bracket"
            }
        ],
        "overviews": [
            {
                "id": 89,
                "html": "<font face=\"Arial\"><div><font color=\"#2d2d2d\">L &#8211; Bracket that attaches the Ali Rail directly to the roof.</font></div><div><font color=\"#2d2d2d\"><br></font></div><div><font color=\"#2d2d2d\">Places where you will use the L &#8211; Bracket:</font></div><div><font color=\"#2d2d2d\"><br></font></div><div><font color=\"#2d2d2d\">Attaches the Ali Rail directly onto the roof</font></div><div><font color=\"#2d2d2d\">Attaches the Ali Rail directly onto the Klip Lock Bracket</font></div><div><font color=\"#2d2d2d\">Attaches the Ali Rail directly onto the Roof Hook (Tile Roof Bracket)</font></div></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with a Stitching Screw (12&#215;20 with seal), which are often used on any regular surface.</font></div><div><font face=\"Arial\"><br></font></div><div><font face=\"Arial\">No additional waterproofing required as the bracket come supplied with a full-size waterproof rubber pad adhesive to the bracket under surface.</font></div></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><b><br></b></font></u></span></div><div><ul><li><span><font face=\"Arial\">1 x Elvic L Bracket<br></font></span></li><li><span><font face=\"Arial\">1 x Rubber Sealant Tape<br></font></span></li><li><span><font face=\"Arial\">1 x Stitching Screws</font></span></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 55,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-04.png"
            },
            {
                "id": 51,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005.png"
            },
            {
                "id": 52,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-01.png"
            },
            {
                "id": 54,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-03.png"
            },
            {
                "id": 56,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-05.png"
            },
            {
                "id": 58,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-07.png"
            },
            {
                "id": 53,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-02.png"
            },
            {
                "id": 57,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-005-06.png"
            }
        ],
        "distributors": [
            {
                "id": 86,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/l-bracket/",
                "code": "SC-ELV-005",
                "sku": "Elvic 005",
                "inventoryStatus": "INSTOCK",
                "cost": 13.04,
                "markup": 0.15,
                "retail": 15
            }
        ],
        "ratings": [
            {
                "id": 142,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 153,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 107,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 89,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 19,
        "uid": "dd344df8-0944-11ef-b2d8-4e2528fc3ca0",
        "code": "SC-ELV-006",
        "name": "Anti Theft Bracket",
        "longName": "End Stopper Anti Theft Bracket (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-006.png",
        "price": 26,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft",
        "description": "End Stopper Anti Theft Bracket (50 sets per Box)",
        "root": "end-stopper-anti-theft",
        "visible": true,
        "highlights": [
            {
                "id": 303,
                "label": "Type",
                "value": "End Stopper - Anti Theft"
            },
            {
                "id": 302,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 91,
                "html": "<font face=\"Arial\"><div><font color=\"#2d2d2d\">For the first and last panels of the Ali Rail, the End Clamp (Anti-Theft) should be used in conjunction with the Mid Clamp (On the perimeter of an array). Secure a solar panel with a 30, 35, or 40 mm depth.</font></div><div><font color=\"#2d2d2d\"><br></font></div><div><font color=\"#2d2d2d\">Only the Ali Rail 4.4m is intended to be used with this End Stopper (Anti-Theft).</font></div></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; come as a pair and is equipped with 2 x Rivets to attach the End Stopper to the Rail for extra securement.</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><b><br></b></font></u></span></div><div><ul><li><span><font face=\"Arial\">2 x El-Vic Anti Theft end Stopper<br></font></span></li><li><span><font face=\"Arial\">2 x 3.2 x 12 Alu Rivets</font></span></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 65,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-02.png"
            },
            {
                "id": 63,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006.png"
            },
            {
                "id": 66,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-03.png"
            },
            {
                "id": 64,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-01.png"
            }
        ],
        "distributors": [
            {
                "id": 88,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/end-stopper-anti-theft/",
                "code": "SC-ELV-006",
                "sku": "Elvic 006",
                "inventoryStatus": "INSTOCK",
                "cost": 22.61,
                "markup": 0.15,
                "retail": 26
            }
        ],
        "ratings": [
            {
                "id": 129,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 143,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 115,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 131,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 18,
        "uid": "9ae6a032-0943-11ef-91f0-4e2528fc3ca0",
        "code": "SC-ELV-006-PC",
        "name": "Anti Theft Bracket (Powder Coated)",
        "longName": "End Stopper Anti Theft Black Powder Coated (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-006-PC.png",
        "price": 0,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, Black, Powder, Coated, End Stopper, Anti Theft, Black Powder Coated",
        "description": "End Stopper Anti Theft Black Powder Coated (50 sets per Box)",
        "root": "end-stopper-anti-theft-black-powder-coated",
        "visible": true,
        "highlights": [
            {
                "id": 300,
                "label": "Installation Difficulty",
                "value": "Easy"
            },
            {
                "id": 301,
                "label": "Type",
                "value": "End Stopper - Anti Theft"
            }
        ],
        "overviews": [
            {
                "id": 90,
                "html": "<font face=\"Arial\"><div><font color=\"#2d2d2d\">For the first and last panels of the Ali Rail, the End Clamp (Anti-Theft) should be used in conjunction with the Mid Clamp (On the perimeter of an array). Secure a solar panel with a 30, 35, or 40 mm depth.</font></div><div><font color=\"#2d2d2d\"><br></font></div><div><font color=\"#2d2d2d\">Only the Ali Rail 4.4m is intended to be used with this End Stopper (Anti-Theft).</font></div></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; come as a pair and is equipped with 2 x Rivets to attach the End Stopper to the Rail for extra securement.</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><span><u><font face=\"Arial\"><b><br></b></font></u></span></div><div><ul><li><span><font face=\"Arial\">2 x El-Vic Anti Theft end Stopper<br></font></span></li><li><span><font face=\"Arial\">2 x 3.2 x 12 Alu Rivets</font></span></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 61,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-PC-02.png"
            },
            {
                "id": 60,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-PC-01.png"
            },
            {
                "id": 62,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-PC-03.png"
            },
            {
                "id": 59,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-006-PC.png"
            }
        ],
        "distributors": [
            {
                "id": 87,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/end-stopper-anti-theft-black-powder-coated-50-sets-per-box-copy/",
                "code": "SC-ELV-006-PC",
                "sku": "Elvic 006-PC",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.15,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 125,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 121,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 120,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 105,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 14,
        "uid": "a807c164-07c8-11ef-b340-4e2528fc3ca0",
        "code": "SC-ELV-003",
        "name": "End Stopper – Ali Rail Short",
        "longName": "End Stopper – Ali Rail Short (100 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-003.png",
        "price": 13,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps & Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, End, Stopper, End Stopper",
        "description": "End Stopper – Ali Rail Short (100 sets per Box)",
        "root": "end-stopper",
        "visible": true,
        "highlights": [
            {
                "id": 292,
                "label": "Type",
                "value": "End Stopper"
            },
            {
                "id": 291,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 86,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">End Clamp, designed to hold only solar panels with a depth of 35mm, to be used in conjunction with the Mid Clamp on the first and last panels of the Ali Rail and/or Ali Short Rail (on the edge of an array).</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font color=\"#2d2d2d\" face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with a Stitching Screw to attach the End Stopper to the Rail for extra securement.<br></font></div><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u><br></div><div><span><u><font face=\"Arial\"><br></font></u></span></div><div><ul><li><font face=\"Arial\">1 x El-Vic End Stopper (35mm Panel)<br>1 x Type 17 Hex Screws 12&#215;40<br></font></li></ul></div><div><span><br></span></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 29,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-003-01.png"
            },
            {
                "id": 30,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-003-02.png"
            },
            {
                "id": 28,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-003.png"
            },
            {
                "id": 31,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-003-03.png"
            },
            {
                "id": 32,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-003-04.png"
            }
        ],
        "distributors": [
            {
                "id": 83,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/end-stopper/",
                "code": "SC-ELV-003",
                "sku": "Elvic 003",
                "inventoryStatus": "INSTOCK",
                "cost": 11.3,
                "markup": 0.15,
                "retail": 13
            }
        ],
        "ratings": [
            {
                "id": 102,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 114,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 154,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 96,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 23,
        "uid": "b26226a0-09e3-11ef-8436-4e2528fc3ca0",
        "code": "SC-ELV-008",
        "name": "Klip Lock Bracket",
        "longName": "Klip Lock Bracket (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-008.png",
        "price": 66,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp, Klip Lock Bracket",
        "description": "Klip Lock Bracket (50 sets per Box) - Brackets to be used on Klip Lock roofs",
        "root": "klip-lock-bracket",
        "visible": true,
        "highlights": [
            {
                "id": 309,
                "label": "Type",
                "value": "Klip Lock Bracket"
            },
            {
                "id": 308,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 94,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">The Klip-Lock bracket provides an easy way to mount solar panels on Klip-Lock type roofs &#8211; without penetrations.&#160; The Klip-Lock Bracket is a small platform that clamps on to the Klip-Lock roof &#8216;ribs&#8217;. An Adjust Roof Rail Clamp or L &#8211; Bracket is then fixed to the Klip-Lock Bracket in order to attach the Rail to the Klip Lock Roof &#8216;ribs&#8217;.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with a M8 stainless steel bolt and nut to secure the Klip Lock Bracket to the Klip-Lock roof &#8216;ribs&#8217; without drilling through the tin.</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>2 x El-Vic Klip Lock Bracket<br></li><li>1 x S/S Bolt and Nut<br></li><li>1 x Hex Tek screws (12&#215;20)<br></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 113,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-06.png"
            },
            {
                "id": 115,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-08.png"
            },
            {
                "id": 117,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-10.png"
            },
            {
                "id": 119,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-12.png"
            },
            {
                "id": 107,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008.png"
            },
            {
                "id": 110,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-03.png"
            },
            {
                "id": 118,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-11.png"
            },
            {
                "id": 122,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-15.png"
            },
            {
                "id": 114,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-07.png"
            },
            {
                "id": 109,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-02.png"
            },
            {
                "id": 111,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-04.png"
            },
            {
                "id": 121,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-14.png"
            },
            {
                "id": 112,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-05.png"
            },
            {
                "id": 116,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-09.png"
            },
            {
                "id": 108,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-01.png"
            },
            {
                "id": 120,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-13.png"
            }
        ],
        "distributors": [
            {
                "id": 91,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/klip-lock-bracket/",
                "code": "SC-ELV-008",
                "sku": "Elvic 008",
                "inventoryStatus": "INSTOCK",
                "cost": 57.39,
                "markup": 0.15,
                "retail": 66
            }
        ],
        "ratings": [
            {
                "id": 137,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 138,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 94,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 126,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 24,
        "uid": "15c82aa4-09e5-11ef-88b1-4e2528fc3ca0",
        "code": "SC-ELV-008-PC",
        "name": "Klip Lock Bracket Black Powder Coated",
        "longName": "Klip Lock Bracket - Black Powder Coated (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-008-PC.png",
        "price": 0,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 5,
        "reviews": 1,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp, Klip Lock Bracket",
        "description": "Klip Lock Bracket - Black Powder Coated (50 sets per Box) - Brackets to be used on Klip Lock roofs",
        "root": "klip-lock-bracket-black-powder-coated",
        "visible": true,
        "highlights": [
            {
                "id": 310,
                "label": "Installation Difficulty",
                "value": "Easy"
            },
            {
                "id": 311,
                "label": "Type",
                "value": "Klip Lock Bracket"
            }
        ],
        "overviews": [
            {
                "id": 95,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">The Klip-Lock bracket provides an easy way to mount solar panels on Klip-Lock type roofs &#8211; without penetrations.&#160; The Klip-Lock Bracket is a small platform that clamps on to the Klip-Lock roof &#8216;ribs&#8217;. An Adjust Roof Rail Clamp or L &#8211; Bracket is then fixed to the Klip-Lock Bracket in order to attach the Rail to the Klip Lock Roof &#8216;ribs&#8217;.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with a M8 stainless steel bolt and nut to secure the Klip Lock Bracket to the Klip-Lock roof &#8216;ribs&#8217; without drilling through the tin.</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>2 x El-Vic Klip Lock Bracket<br></li><li>1 x S/S Bolt and Nut<br></li><li>1 x Hex Tek screws (12&#215;20)<br></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 128,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-05.png"
            },
            {
                "id": 131,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-08.png"
            },
            {
                "id": 125,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-02.png"
            },
            {
                "id": 135,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-12.png"
            },
            {
                "id": 137,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-14.png"
            },
            {
                "id": 130,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-07.png"
            },
            {
                "id": 126,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-03.png"
            },
            {
                "id": 134,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-11.png"
            },
            {
                "id": 138,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-15.png"
            },
            {
                "id": 132,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-09.png"
            },
            {
                "id": 129,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-06.png"
            },
            {
                "id": 127,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-04.png"
            },
            {
                "id": 133,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-10.png"
            },
            {
                "id": 123,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC.png"
            },
            {
                "id": 124,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-01.png"
            },
            {
                "id": 136,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-008-PC-13.png"
            }
        ],
        "distributors": [
            {
                "id": 92,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/klip-lock-bracket-black-powder-coated-50-sets-per-box/",
                "code": "SC-ELV-008-PC",
                "sku": "Elvic 008-PC",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.15,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 117,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 123,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 109,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 104,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 21,
        "uid": "b50920ce-094e-11ef-a48f-4e2528fc3ca0",
        "code": "SC-ELV-007",
        "name": "Mid Clamp",
        "longName": "Mid Clamp (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-007.png",
        "price": 66,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp",
        "description": "Mid Clamp (50 sets per Box)",
        "root": "mid-clamp",
        "visible": true,
        "highlights": [
            {
                "id": 305,
                "label": "Type",
                "value": "Mid Clamp"
            },
            {
                "id": 304,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 92,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">Each Mid-Clamp is shared by two adjacent Solar panels, and at the start and end (perimeter of an array), you will use the Mid Clamp in conjunction with the End Stopper or Anti-theft bracket. The Mid-Clamp has four distinct symmetrical clamping surfaces for attaching adjacent Solar panels onto the Rail.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><div><font face=\"Arial\">High Quality Material: The Mid-Clamp and Panels are secured to the Rail by a Stitching Screw after the panels have been aligned. They are made of lightweight aluminum with good corrosion resistance and weather resistance.</font></div><div><font face=\"Arial\"><br></font></div><div><font face=\"Arial\">Click and Go. Easy to install. No need to slide flat nuts into the Rail.</font></div><div><font face=\"Arial\">Secure Solar Panels with a depth of 30, 35 or 40mm.</font></div></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>1 x El-Vic Mid Clamp (30/35/40mm Panels)<br></li><li>1 x Type 17 Hex Screws (65mm)<br></li><li>1 x M8 Hex Full Nuts Z/P (Use on 35mm Panels)<br></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 77,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-10.png"
            },
            {
                "id": 80,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-13.png"
            },
            {
                "id": 67,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007.png"
            },
            {
                "id": 68,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-01.png"
            },
            {
                "id": 70,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-03.png"
            },
            {
                "id": 76,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-09.png"
            },
            {
                "id": 79,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-12.png"
            },
            {
                "id": 83,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-16.png"
            },
            {
                "id": 71,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-04.png"
            },
            {
                "id": 75,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-08.png"
            },
            {
                "id": 84,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-17.png"
            },
            {
                "id": 72,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-05.png"
            },
            {
                "id": 74,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-07.png"
            },
            {
                "id": 82,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-15.png"
            },
            {
                "id": 86,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-19.png"
            },
            {
                "id": 78,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-11.png"
            },
            {
                "id": 81,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-14.png"
            },
            {
                "id": 85,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-18.png"
            },
            {
                "id": 69,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-02.png"
            },
            {
                "id": 73,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-06.png"
            }
        ],
        "distributors": [
            {
                "id": 89,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/mid-clamp/",
                "code": "SC-ELV-007",
                "sku": "Elvic 007",
                "inventoryStatus": "INSTOCK",
                "cost": 57.39,
                "markup": 0.15,
                "retail": 66
            }
        ],
        "ratings": [
            {
                "id": 106,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 151,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 100,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 122,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 22,
        "uid": "18cea244-09d8-11ef-81be-4e2528fc3ca0",
        "code": "SC-ELV-007-PC",
        "name": "Mid Clamp Black Powder Coated",
        "longName": "Mid Clamp Black Powder Coated (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-007-PC.png",
        "price": 0,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 5,
        "reviews": 1,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp",
        "description": "Mid Clamp Black Powder Coated (50 sets per Box)",
        "root": "mid-clamp-black-powder-coated",
        "visible": true,
        "highlights": [
            {
                "id": 306,
                "label": "Installation Difficulty",
                "value": "Easy"
            },
            {
                "id": 307,
                "label": "Type",
                "value": "Mid Clamp (Black Powder Coated)"
            }
        ],
        "overviews": [
            {
                "id": 93,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">Each Mid-Clamp is shared by two adjacent Solar panels, and at the start and end (perimeter of an array), you will use the Mid Clamp in conjunction with the End Stopper or Anti-theft bracket. The Mid-Clamp has four distinct symmetrical clamping surfaces for attaching adjacent Solar panels onto the Rail.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><div><font face=\"Arial\">High Quality Material: The Mid-Clamp and Panels are secured to the Rail by a Stitching Screw after the panels have been aligned. They are made of lightweight aluminum with good corrosion resistance and weather resistance.</font></div><div><font face=\"Arial\"><br></font></div><div><font face=\"Arial\">Click and Go. Easy to install. No need to slide flat nuts into the Rail.</font></div><div><font face=\"Arial\">Secure Solar Panels with a depth of 30, 35 or 40mm.</font></div></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>1 x El-Vic Mid Clamp (30/35/40mm Panels)<br></li><li>1 x Type 17 Hex Screws (65mm)<br></li><li>1 x M8 Hex Full Nuts Z/P (Use on 35mm Panels)<br></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 89,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-02.png"
            },
            {
                "id": 104,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-17.png"
            },
            {
                "id": 99,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-12.png"
            },
            {
                "id": 92,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-05.png"
            },
            {
                "id": 94,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-07.png"
            },
            {
                "id": 91,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-04.png"
            },
            {
                "id": 95,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-08.png"
            },
            {
                "id": 93,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-06.png"
            },
            {
                "id": 100,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-13.png"
            },
            {
                "id": 103,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-16.png"
            },
            {
                "id": 88,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-01.png"
            },
            {
                "id": 90,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-03.png"
            },
            {
                "id": 96,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-09.png"
            },
            {
                "id": 87,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC.png"
            },
            {
                "id": 105,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-18.png"
            },
            {
                "id": 106,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-19.png"
            },
            {
                "id": 97,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-10.png"
            },
            {
                "id": 98,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-11.png"
            },
            {
                "id": 101,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-14.png"
            },
            {
                "id": 102,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-007-PC-15.png"
            }
        ],
        "distributors": [
            {
                "id": 90,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/mid-clamp-black-powder-coated-50-sets-per-box-copy/",
                "code": "SC-ELV-007-PC",
                "sku": "Elvic 007-PC",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.15,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 116,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 101,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 150,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 113,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 25,
        "uid": "77d278a4-09ee-11ef-8cc9-4e2528fc3ca0",
        "code": "SC-ELV-009",
        "name": "Rail Joint Kit",
        "longName": "Rail Joint Kit (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-009.png",
        "price": 24,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp, Klip Lock Bracket, Rail, Joint, Kit, Rail Joint Kit",
        "description": "Rail Joint Kit (50 sets per Box)",
        "root": "rail-joint-kit",
        "visible": true,
        "highlights": [
            {
                "id": 313,
                "label": "Type",
                "value": "Rail Joint Kit"
            },
            {
                "id": 312,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 96,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">In order to extend the rail to the desired length, you will join two or more rails together using the Rail Joint Kit, which is exactly what it says it is. It will be used on both sides of the rail for extra rigidness; hence the unit is sold in sets of two.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with 4 x Stitching Screws (2 on each side) to firmly attach the Rail Joint Kit to the Rail for extra rigidness.</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>2 x El-Vic Rail Joints<br></li><li>4 x Stitching Screws</li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 141,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-02.png"
            },
            {
                "id": 142,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-03.png"
            },
            {
                "id": 145,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-06.png"
            },
            {
                "id": 140,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-01.png"
            },
            {
                "id": 143,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-04.png"
            },
            {
                "id": 144,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-05.png"
            },
            {
                "id": 139,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009.png"
            }
        ],
        "distributors": [
            {
                "id": 93,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/rail-joint-kit/",
                "code": "SC-ELV-009",
                "sku": "Elvic 009",
                "inventoryStatus": "INSTOCK",
                "cost": 20.87,
                "markup": 0.15,
                "retail": 24
            }
        ],
        "ratings": [
            {
                "id": 91,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 147,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 98,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 152,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 26,
        "uid": "59e24314-09ef-11ef-801c-4e2528fc3ca0",
        "code": "SC-ELV-009-PC",
        "name": "Rail Joint Kit Black Powder Coated",
        "longName": "Rail Joint Kit Black Powder Coated (50 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-009-PC.png",
        "price": 0,
        "category": "Mounting Structures",
        "subCategory": "Accessories",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 5,
        "reviews": 1,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp, Klip Lock Bracket, Rail, Joint, Kit, Rail Joint Kit Black Powder Coated",
        "description": "Rail Joint Kit Black Powder Coated (50 sets per Box)",
        "root": "rail-joint-kit-black-powder-coated",
        "visible": true,
        "highlights": [
            {
                "id": 315,
                "label": "Type",
                "value": "Rail Joint Kit"
            },
            {
                "id": 314,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 97,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">In order to extend the rail to the desired length, you will join two or more rails together using the Rail Joint Kit, which is exactly what it says it is. It will be used on both sides of the rail for extra rigidness; hence the unit is sold in sets of two.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><font face=\"Arial\">High Quality Material: Made of lightweight aluminum with excellent corrosion resistance and weather resistance; equipped with 4 x Stitching Screws (2 on each side) to firmly attach the Rail Joint Kit to the Rail for extra rigidness.</font><br></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>2 x El-Vic Rail Joints<br></li><li>4 x Stitching Screws</li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 150,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC-04.png"
            },
            {
                "id": 147,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC-01.png"
            },
            {
                "id": 149,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC-03.png"
            },
            {
                "id": 151,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC-05.png"
            },
            {
                "id": 148,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC-02.png"
            },
            {
                "id": 146,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC.png"
            },
            {
                "id": 152,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-009-PC-06.png"
            }
        ],
        "distributors": [
            {
                "id": 94,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/rail-joint-kit-black-powder-coated-50-sets-per-box/",
                "code": "SC-ELV-009-PC",
                "sku": "Elvic 009-PC",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.15,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 134,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 156,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 90,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 140,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 28,
        "uid": "988e2394-0dcd-11ef-b7b3-4e2528fc3ca0",
        "code": "SC-ELV-M102-ALL",
        "name": "Tile Roof Bracket with Clamp",
        "longName": "Tile Roof Bracket with Clamp (10 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL.png",
        "price": 132,
        "category": "Mounting Structures",
        "subCategory": "Roof Brackets",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp, Klip Lock Bracket, Rail, Joint, Kit, Rail Joint Kit Black Powder Coated, Tile Roof Brackets, Tile, Roof, Brackets",
        "description": "Tile Roof Bracket with Clamp (10 sets per Box)",
        "root": "tile-roof-bracket-with-clamp",
        "visible": true,
        "highlights": [
            {
                "id": 318,
                "label": "Installation Difficulty",
                "value": "Easy"
            },
            {
                "id": 319,
                "label": "Type",
                "value": "Tile Roof Bracket"
            }
        ],
        "overviews": [
            {
                "id": 99,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">Tile Roof Bracket with clamp.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><ul><li><font face=\"Arial\">High Quality Material: Made of 4mm Mild Steel</font><br></li><li><font face=\"Arial\">Electro Plated for corrosion and weather resistance<br></font></li><li><font face=\"Arial\">Compatible with most Clay and Tile roof structures.<br></font></li></ul></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>1 x 3 Piece 4mm Metal Bracket (E/Plated)<br></li><li>3 x M8 Bolt and Nut</li><li>3 x Type 17 Hex Screws 12&#215;40<br></li><li>1 x El-Vic L Bracket<br></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 163,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-07.png"
            },
            {
                "id": 156,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL.png"
            },
            {
                "id": 157,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-01.png"
            },
            {
                "id": 159,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-03.png"
            },
            {
                "id": 161,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-05.png"
            },
            {
                "id": 162,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-06.png"
            },
            {
                "id": 158,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-02.png"
            },
            {
                "id": 160,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-ALL-04.png"
            }
        ],
        "distributors": [
            {
                "id": 96,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/tile-roof-bracket-with-clamp-10-sets-per-box/",
                "code": "SC-ELV-M102-ALL",
                "sku": "Elvic M102-ALL",
                "inventoryStatus": "INSTOCK",
                "cost": 114.78,
                "markup": 0.15,
                "retail": 132
            }
        ],
        "ratings": [
            {
                "id": 148,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 110,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 146,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 132,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 27,
        "uid": "586ca6f0-0d7d-11ef-a293-bf8ccb1001e2",
        "code": "SC-ELV-M102-0",
        "name": "Tile Roof Brackets",
        "longName": "Tile Roof Brackets (10 sets per Box)",
        "brand": "Elvic",
        "image": "https://www.solarcentral.co.za/images/SC-ELV-M102-0.png",
        "price": 120,
        "category": "Mounting Structures",
        "subCategory": "Roof Brackets",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | PV Panel Mounting Structures Clamps, Accessories",
        "keywords": "Elvic, Clamps, Accessories, Mounting Structures, PV Panel, Polycrystalline, Monocrystalline, Ali Rail, Aluminium, Aluminum, End, Stopper, Anti, Theft, End Stopper, Anti Theft, Mid Clamp, Klip Lock Bracket, Rail, Joint, Kit, Rail Joint Kit Black Powder Coated, Tile Roof Brackets, Tile, Roof, Brackets",
        "description": "Tile Roof Brackets (10 sets per Box)",
        "root": "tile-roof-brackets",
        "visible": true,
        "highlights": [
            {
                "id": 317,
                "label": "Type",
                "value": "Roof Bracket"
            },
            {
                "id": 316,
                "label": "Installation Difficulty",
                "value": "Easy"
            }
        ],
        "overviews": [
            {
                "id": 98,
                "html": "<font face=\"Arial\"><font color=\"#2d2d2d\">Tile Roof Bracket.</font><br></font><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><h3><font color=\"#2d2d2d\" face=\"Arial\"><b><u>Features:</u></b></font></h3><div><font color=\"#2d2d2d\" face=\"Arial\"><br></font></div><div><div><ul><li><font face=\"Arial\">High Quality Material: Made of 4mm Mild Steel</font></li><li><font face=\"Arial\">Electro Plated for corrosion and weather resistance</font></li><li><font face=\"Arial\">Compatible with most Clay and Tile roof structures</font></li></ul></div></div><div><font face=\"Arial\"><br></font></div><div><h3><span><u><font face=\"Arial\"><b>What&#8217;s in a set?</b></font></u></span></h3></div><div><br></div><div><ul><li>1 x 3 Piece 4mm Metal Bracket (E/Plated)<br></li><li>2 x M8 Bolt and Nut</li><li>3 x Type 17 Hex Screws 12&#215;40<br></li><li>0 x El-Vic L Bracket<br></li></ul></div>"
            }
        ],
        "specifications": [],
        "documents": [],
        "images": [
            {
                "id": 153,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-0.png"
            },
            {
                "id": 155,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-0-02.png"
            },
            {
                "id": 154,
                "url": "https://www.solarcentral.co.za/images/SC-ELV-M102-0-01.png"
            }
        ],
        "distributors": [
            {
                "id": 95,
                "distributor": "Elvic",
                "distributorClient": "za.co.visualage.inventory.distributor.ElvicDistributorClient",
                "refreshUrl": "https://elvic.co.za/product/tile-roof-brackets-10-sets-per-box/",
                "code": "SC-ELV-M102-0",
                "sku": "El-Vic M102 -0",
                "inventoryStatus": "INSTOCK",
                "cost": 104.35,
                "markup": 0.15,
                "retail": 120
            }
        ],
        "ratings": [
            {
                "id": 130,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 133,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 99,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 144,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 36,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-MPS0100",
        "name": "100KW Solar Storage",
        "longName": "Growcol 100KW Solar Storage Hybrid Inverter (GRO-MPS0100)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-MPS0100.png",
        "price": 416806,
        "category": "Inverters",
        "subCategory": "Commercial, Grid-Tied",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 100KW Solar Storage Hybrid Inverter",
        "keywords": "Growcol 100KW Solar Storage Hybrid Inverter, solar, accredited installers, south africa, solar quotes, pv-panels, PV Panels, inverter, 5kw, 10kw, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, Kwazulu-Natal",
        "description": "Growcol 100KW Solar Storage Hybrid Inverter (GRO-GW-MPS0100)",
        "root": "growcol-100kw-solar-storage",
        "visible": true,
        "highlights": [
            {
                "id": 17,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 20,
                "label": "Warranty",
                "value": "2 Years"
            },
            {
                "id": 18,
                "label": "Input Voltage",
                "value": "100 kW"
            },
            {
                "id": 19,
                "label": "Rated Current",
                "value": "144A"
            }
        ],
        "overviews": [
            {
                "id": 5,
                "html": "Large-scale solar energy systems can be supported by inverters like the Growcol 100KW Solar Storage Hybrid Inverter. It has the ability to distribute and manage the power produced by a solar panel array while also storing any extra power in batteries for later use.<div><br></div><div><div>The Growcol 100KW Solar Storage Hybrid Inverter also incorporates advanced monitoring and control capabilities. It comes with a user-friendly interface that allows users to monitor real-time energy generation, consumption, and battery status. Additionally, it offers intelligent energy management features such as load shifting and peak shaving, enabling users to optimise their energy usage and reduce electricity bills.</div><div><br></div><div>The inverter is designed with high-quality components and advanced safety features. It includes built-in protection mechanisms to safeguard against overvoltage, overcurrent, short circuits, and other electrical faults. This ensures the safety and longevity of the system and provides peace of mind to users.</div><div><br></div><div>Overall, the Growcol 100KW Solar Storage Hybrid Inverter is a versatile and efficient solution for harnessing solar energy and storing it for later use. With its high power output, energy storage capabilities, and intelligent control features, it offers a reliable and cost-effective way to reduce reliance on the grid and transition to clean, sustainable energy sources.</div></div><div><br></div><div>The Growcol 100KW Solar Storage Hybrid Inverter offers several impressive features that make it a standout choice for solar power generation and energy storage.&#160;</div><div><b><br></b></div><div><b>Here are some of its best features:</b><br></div><div><br></div><div><ul><li>1. High Power Output: The inverter is capable of handling a substantial power output of 100KW, making it suitable for larger-scale residential and commercial installations.<br></li><li>2. Solar Integration: It seamlessly integrates with solar PV systems, efficiently converting the DC power generated by solar panels into AC power for immediate consumption or storage.<br></li><li>3. Energy Storage Functionality: The built-in battery system allows excess solar energy to be stored for later use, providing a reliable backup power supply during periods of low sunlight or power outages.<br></li><li>4. Intelligent Energy Management: The inverter offers advanced energy management features such as load shifting and peak shaving, allowing users to optimize their energy usage and reduce electricity bills.<br></li><li>5. Real-time Monitoring and Control: It includes a user-friendly interface that enables real-time monitoring of energy generation, consumption, and battery status. Users can easily track their energy usage and system performance.<br></li><li>6. Safety Features: The inverter incorporates built-in protection mechanisms against overvoltage, overcurrent, short circuits, and other electrical faults, ensuring the safety and longevity of the system.<br></li><li>7. Greater Energy Independence: With its energy storage capabilities, the inverter reduces reliance on the grid and enhances energy independence by providing a reliable and self-sustaining power supply.<br></li><li>8. Scalability: The Growcol 100KW Solar Storage Hybrid Inverter is designed to be scalable, allowing for the expansion of the solar PV system and battery capacity as energy needs grow.<br></li><li>9. High-Quality Components: The inverter is built with high-quality components, ensuring reliability, efficiency, and durability over the long term.<br></li><li>10. Environmentally Friendly: By harnessing solar energy, the inverter helps reduce carbon emissions and reliance on fossil fuels, contributing to a cleaner and more sustainable environment.</li></ul></div><div>These features collectively make the Growcol 100KW Solar Storage Hybrid Inverter an excellent choice for those looking to optimise their solar power generation, energy storage, and overall energy management capabilities.<br></div><div><br></div>"
            }
        ],
        "specifications": [
            {
                "id": 265,
                "label": "Max. PV Power",
                "value": "120/180/240kW"
            },
            {
                "id": 266,
                "label": "PV MPPT Voltage Range",
                "value": "200V - 850V"
            },
            {
                "id": 262,
                "label": "Power Output",
                "value": "100kW"
            },
            {
                "id": 263,
                "label": "Voltage Range",
                "value": "320V - 460V"
            },
            {
                "id": 807,
                "label": "Parallel Operation",
                "value": "4"
            },
            {
                "id": 271,
                "label": "Display",
                "value": "Touch Screen LCD"
            },
            {
                "id": 269,
                "label": "Environmental Temperature",
                "value": "-25°C ~ +55°C"
            },
            {
                "id": 264,
                "label": "Max. PV Open-Circuit Voltage",
                "value": "1000VDC"
            },
            {
                "id": 268,
                "label": "Weight",
                "value": "900kg"
            },
            {
                "id": 270,
                "label": "Communication Interface",
                "value": "RS485/CAN"
            },
            {
                "id": 267,
                "label": "Dimensions (W x D x H)",
                "value": "1200x800x2050mm"
            }
        ],
        "documents": [
            {
                "id": 11,
                "description": "MPS User Manual",
                "url": "https://www.solarcentral.co.za/pdf/MPS-User-Manual"
            },
            {
                "id": 12,
                "description": "Growcol - Commercial Inverter - MPS - TUV Certificate AK50573567_0001",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-Commercial-Inverter-MPS-TUV-Certificate-AK50573567_0001.pdf"
            },
            {
                "id": 10,
                "description": "MPS Range",
                "url": "https://www.solarcentral.co.za/pdf/MPS-Range.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 5,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol100kw-solar-storage-hybrid-inverter/",
                "code": "GRO-MPS0100",
                "sku": "GW-MPS0100",
                "inventoryStatus": "LOWSTOCK",
                "cost": 416806,
                "markup": 0,
                "retail": 416806
            }
        ],
        "ratings": [
            {
                "id": 7,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 49,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 47,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 37,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 1,
        "uid": "c5cc8600-cca7-11ee-9459-db1b00c3fac1",
        "code": "SS-1P-10K-H-LV",
        "name": "10kW Inverter 48V + Wifi",
        "longName": "Sunsynk 10kW Single Phase Hybrid PV Inverter 48v C/W Wifi Dongle IP65",
        "brand": "Sunsynk",
        "image": "https://www.solarcentral.co.za/images/SS-1P-10K-H-LV.png",
        "price": 36731,
        "category": "Inverters",
        "subCategory": "Residential, Hybrid",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 5,
        "reviews": 1,
        "title": "Solar Central | Products | Sunsynk 10kW Hybrid Inverter 48v",
        "keywords": "Sunsynk, 10kW, Hybrid Inverter, 48v, Inverter, Inverters, Residential, Hybrid",
        "description": "Sunsynk 10kW Single Phase Hybrid PV Inverter 48v C/W Wifi Dongle IP65",
        "root": "sunsynk-10kw-48v-wifi",
        "visible": true,
        "highlights": [
            {
                "id": 244,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 247,
                "label": "Max AC Power",
                "value": "13000W"
            },
            {
                "id": 245,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 246,
                "label": "Input Power",
                "value": "10000W"
            }
        ],
        "overviews": [
            {
                "id": 73,
                "html": "<h4>Product Description</h4><div><br></div><div>Sunsynk 10kW Single Phase Hybrid PV Inverter 48v C/W Wifi Dongle IP65</div>"
            }
        ],
        "specifications": [
            {
                "id": 766,
                "label": "PV Input Voltage",
                "value": "370V (125V~500V)"
            },
            {
                "id": 768,
                "label": "No. of MPPT Trackers",
                "value": "2"
            },
            {
                "id": 769,
                "label": "PV Input Current",
                "value": "26Ad.c + 26Ad.c"
            },
            {
                "id": 805,
                "label": "Power Output",
                "value": "10kW"
            },
            {
                "id": 767,
                "label": "MPPT Range",
                "value": "150~425V"
            },
            {
                "id": 765,
                "label": "Max. DC Input Power",
                "value": "13000W"
            },
            {
                "id": 770,
                "label": "Max PV Isc",
                "value": "44Ad.c + 44Ad.c"
            },
            {
                "id": 815,
                "label": "Parallel Operation",
                "value": "6"
            }
        ],
        "documents": [],
        "images": [],
        "distributors": [
            {
                "id": 69,
                "distributor": "Heroldts",
                "distributorClient": "za.co.visualage.inventory.distributor.HerholdtsDistributorClient",
                "refreshUrl": "https://herholdts.co.za/pi61545/sunsynk%2D10kw%2D1p%2Dhybrid%2Dpv%2Dinverter%2D48v%2Dc%2Dw%2Dwifi%2Ddongle%2Dip65/",
                "code": "SS-1P-10K-H-LV",
                "sku": "SS-1P-10K-H-LV",
                "inventoryStatus": "INSTOCK",
                "cost": 35318.27,
                "markup": 0.04,
                "retail": 36731
            }
        ],
        "ratings": [
            {
                "id": 34,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 27,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 1,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 30,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 37,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-MPS0150",
        "name": "150kW Solar Storage",
        "longName": "Growcol 150kW Solar Storage Hybrid Inverter (GRO-MPS0150)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-MPS0150.png",
        "price": 526960.59,
        "category": "Inverters",
        "subCategory": "Commercial, Grid-Tied",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 150kW Solar Storage Hybrid Inverter",
        "keywords": "Growcol 150kW Solar Storage Hybrid Inverter, solar, accredited installers, south africa, solar quotes, pv-panels, PV Panels, inverter, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, Kwazulu-Natal",
        "description": "An inverter with the capacity to serve large-scale solar energy systems is the Growcol 150kW Solar Storage Hybrid Inverter. It can distribute and control the flow of solar-generated energy while also storing any extra energy in batteries for later use.",
        "root": "growcol-150kw-solar-storage",
        "visible": true,
        "highlights": [
            {
                "id": 21,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 22,
                "label": "Input Voltage",
                "value": "150 kW"
            },
            {
                "id": 24,
                "label": "Warranty",
                "value": "2 Years"
            },
            {
                "id": 23,
                "label": "Rated Current",
                "value": "216A"
            }
        ],
        "overviews": [
            {
                "id": 6,
                "html": "<div>The Growcol 150kW Solar Storage Hybrid Inverter is a cutting-edge renewable energy solution that combines the power of solar energy generation and battery storage to provide efficient and sustainable electricity supply. Designed for commercial and industrial applications, this advanced inverter system offers exceptional performance, reliability, and flexibility.</div><div><br></div><div><b>Key Features:</b></div><div><br></div><div><ul><li>1. High Power Output: With a robust capacity of 150 kilowatts, the Growcol Solar Storage Hybrid Inverter is capable of handling substantial energy loads, making it ideal for large-scale operations and commercial installations.<br></li><li>2. Solar Energy Integration: The inverter seamlessly integrates with solar panels, efficiently converting the captured solar energy into usable electricity. By harnessing the sun's power, businesses can significantly reduce their reliance on traditional energy sources and lower their carbon footprint.<br></li><li>3. Battery Storage Capability: The Growcol Hybrid Inverter features built-in energy storage functionality, allowing excess solar energy to be stored for later use. This capability ensures a steady and reliable power supply, even during periods of low solar generation or at night, optimising energy utilisation and increasing energy independence.<br></li><li>4. Grid Connectivity and Backup: The inverter is designed to connect to the electrical grid, enabling users to feed surplus energy back into the grid and earn credits or compensation through net metering schemes. Additionally, it provides backup power during grid outages, ensuring uninterrupted operation and minimising downtime.<br></li><li>5. Advanced Monitoring and Control: The Growcol Hybrid Inverter incorporates a user-friendly monitoring and control system, allowing users to monitor real-time energy production, consumption, and battery status. This feature provides valuable insights into energy usage patterns, facilitates effective load management, and maximises system efficiency.<br></li><li>6. Scalable and Modular Design: The Growcol system is scalable, allowing for the addition of multiple inverters and battery units to meet evolving energy demands. The modular design facilitates easy installation, maintenance, and future expansion, ensuring adaptability to changing energy requirements.</li><li>7. Durability and Efficiency: Built with high-quality components and advanced engineering, the Growcol Hybrid Inverter ensures long-lasting durability and optimal energy conversion efficiency. It operates with minimal noise and heat generation, enhancing safety and reducing energy wastage.</li></ul><div>The Growcol 150kW Solar Storage Hybrid Inverter offers a comprehensive and intelligent solution for businesses seeking to harness clean and renewable energy. By combining solar energy generation, battery storage, and grid connectivity, this inverter system enables significant cost savings, reduced reliance on fossil fuels, and a more sustainable energy future.<br></div></div>"
            }
        ],
        "specifications": [
            {
                "id": 273,
                "label": "Rated Voltage",
                "value": "400V"
            },
            {
                "id": 272,
                "label": "Power Output",
                "value": "150kW"
            },
            {
                "id": 277,
                "label": "PV MPPT Voltage Range",
                "value": "200V - 850V"
            },
            {
                "id": 274,
                "label": "Voltage Range",
                "value": "320V - 460V"
            },
            {
                "id": 275,
                "label": "Max. PV Open-Circuit Voltage",
                "value": "1000VDC"
            },
            {
                "id": 279,
                "label": "Environmental Temperature",
                "value": "-25°C ~ +55°C"
            },
            {
                "id": 808,
                "label": "Parallel Operation",
                "value": "4"
            },
            {
                "id": 276,
                "label": "Max. PV Power",
                "value": "120/180/240kW"
            },
            {
                "id": 278,
                "label": "Battery Voltage Range",
                "value": "420V - 850V"
            },
            {
                "id": 280,
                "label": "Display",
                "value": "Touch Screen LCD"
            },
            {
                "id": 281,
                "label": "Communication Interface",
                "value": "RS485/CAN"
            }
        ],
        "documents": [
            {
                "id": 13,
                "description": "MPS Range",
                "url": "https://www.solarcentral.co.za/pdf/MPS-Range-150kW.pdf"
            },
            {
                "id": 14,
                "description": "MPS User Manual",
                "url": "https://www.solarcentral.co.za/pdf/MPS-User-Manual-150kW.pdf"
            },
            {
                "id": 15,
                "description": "Growcol - Commercial Inverter - MPS - TUV Certificate AK50573567_0001",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-Commercial-Inverter-MPS-TUV-Certificate-AK50573567_0001-150kW.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 6,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol150kw-solar-storage-hybrid-inverter/",
                "code": "GRO-MPS0150",
                "sku": "GW-MPS0150",
                "inventoryStatus": "LOWSTOCK",
                "cost": 526960.59,
                "markup": 0,
                "retail": 526960.59
            }
        ],
        "ratings": [
            {
                "id": 14,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 2,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 5,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 46,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 38,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-GX110KT",
        "name": "3 Phase 4 MPPT 110kW",
        "longName": "Growcol 3 Phase 4 MPPT 110kW Grid Tied (GRO-GX110KT)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-GX110KT.png",
        "price": 91798.69,
        "category": "Inverters",
        "subCategory": "Commercial, Grid-Tied",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 3 Phase 4 MPPT 110kW Grid Tied",
        "keywords": "Growcol, 3 Phase, 4 MPPT 110kW, Grid Tied, Solar Storage Hybrid Inverter, solar, accredited installers, south africa, solar quotes, pv-panels, PV Panels, inverter, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, Kwazulu-Natal",
        "description": "Growcol 3 Phase 4 MPPT 110kW Grid Tied (GRO-GX110KT)",
        "root": "growcol-3-phase-110kw",
        "visible": true,
        "highlights": [
            {
                "id": 26,
                "label": "Input Voltage",
                "value": "1100V"
            },
            {
                "id": 25,
                "label": "Inverter Type",
                "value": "Grid Tied Inverter"
            },
            {
                "id": 28,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 27,
                "label": "Rated Voltage",
                "value": "110kW"
            }
        ],
        "overviews": [
            {
                "id": 7,
                "html": "<div>The Growcol 3 Phase 4 MPPT 110kW Grid Tied Inverter is a state-of-the-art solar inverter designed to efficiently convert solar energy into usable electricity for commercial and industrial applications. This advanced grid-tied inverter offers high power capacity, multiple maximum power point tracking (MPPT) channels, and seamless integration with the utility grid.</div><div><br></div><h4><b>Key Features:</b></h4><div><br></div><div><ul><li>1. High Power Output: With a robust power rating of 110kW, the Growcol inverter is capable of handling substantial solar energy generation in large-scale installations. It can accommodate the power demands of commercial buildings, industrial facilities, and utility-scale solar farms.<br></li><li>2. Multiple MPPT Channels: The inverter is equipped with four MPPT channels, allowing it to optimise energy harvest from multiple solar arrays with different orientations, tilts, or shading conditions. Each MPPT channel operates independently, ensuring maximum energy yield from the solar panels.<br></li><li>3. Grid-Tied Functionality: The Growcol inverter seamlessly integrates with the utility grid, enabling efficient transfer of excess energy back to the grid. This grid-tied functionality not only allows for the utilisation of solar power on-site but also facilitates the possibility of selling surplus electricity to the grid, maximizing the financial benefits of solar energy installations.<br></li><li>4. Wide Input Voltage Range: The inverter supports a wide input voltage range, accommodating various solar panel configurations and enabling flexible system design. It can handle high voltage inputs, making it suitable for installations with longer strings or in areas with high solar irradiation.<br></li><li>5. Advanced Monitoring and Control: The Growcol inverter provides comprehensive monitoring and control features, allowing users to remotely monitor the system's performance and troubleshoot any issues. It offers real-time data on energy production, power output, and system efficiency, enabling effective system management and optimisation.<br></li><li>6. Robust Build and Durability: Built with high-quality components and designed to withstand challenging environmental conditions, the Growcol inverter ensures long-term reliability and durability. It features robust protection mechanisms against overvoltage, overcurrent, and overheating, safeguarding the system and prolonging its operational life.<br></li><li>7. User-Friendly Interface: The inverter is equipped with an intuitive interface that simplifies the configuration, monitoring, and maintenance processes. It offers a user-friendly graphical display and supports various communication protocols, enabling easy integration with external monitoring systems.</li></ul><div><br></div><div>In summary, the Growcol 3 Phase 4 MPPT 110kW Grid Tied Inverter is a high-performance and versatile solution for large-scale solar energy installations. With its high power output, multiple MPPT channels, grid-tied functionality, and advanced monitoring capabilities, it maximises energy yield, system efficiency, and financial returns, while ensuring long-term reliability.<br></div></div>"
            }
        ],
        "specifications": [
            {
                "id": 288,
                "label": "Max. Efficiency",
                "value": "99.90%"
            },
            {
                "id": 809,
                "label": "Parallel Operation",
                "value": "1"
            },
            {
                "id": 289,
                "label": "Environmental Temperature",
                "value": "-30°C ~ +60°C"
            },
            {
                "id": 286,
                "label": "Max. Apparent Power",
                "value": "110kVa"
            },
            {
                "id": 284,
                "label": "MPPT Voltage Range",
                "value": "180V ~ 1000V"
            },
            {
                "id": 287,
                "label": "Rated Grid Voltage",
                "value": "230V / 400V / 3L+N+PE / 3L+PE"
            },
            {
                "id": 285,
                "label": "Power Output",
                "value": "100kW"
            },
            {
                "id": 290,
                "label": "Display",
                "value": "LED / LCD / Bluetooth & App"
            },
            {
                "id": 291,
                "label": "Communication Interface",
                "value": "RS485 / USB"
            },
            {
                "id": 282,
                "label": "Max. Input Power",
                "value": "110kW"
            },
            {
                "id": 283,
                "label": "Max Input Voltage",
                "value": "1100V"
            }
        ],
        "documents": [
            {
                "id": 17,
                "description": "Growcol-GX-100-136KW-Three-Phase-Grid-Tied-ENS-Report",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-GX-100-136KW-Three-Phase-Grid-Tied-ENS-Report.pdf"
            },
            {
                "id": 16,
                "description": "Growcol-GX-100-136KW-Three-Phase-Grid-Tied-Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-GX-100-136KW-Three-Phase-Grid-Tied-Datasheet.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 7,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol3-phase-4-mppt-110kw-grid-tied/",
                "code": "GRO-GX110KT",
                "sku": "GX110KT",
                "inventoryStatus": "INSTOCK",
                "cost": 91798.69,
                "markup": 0,
                "retail": 91798.69
            }
        ],
        "ratings": [
            {
                "id": 26,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 50,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 20,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 55,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 39,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-GX60",
        "name": "3 Phase 4 MPPT 60kW",
        "longName": "Growcol 3 Phase 4 MPPT 60kW Grid Tied (GRO-GX60)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-GX60.png",
        "price": 46046.81,
        "category": "Inverters",
        "subCategory": "Commercial, Grid-Tied",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 3 Phase 4 MPPT 60kW Grid Tied",
        "keywords": "Growcol, 3 Phase, 4 MPPT 60kW, Grid Tied, Solar Storage, solar, accredited installers, south africa, solar quotes, pv-panels, PV Panels, inverter, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, Kwazulu-Natal",
        "description": "Growcol 3 Phase 4 MPPT 60kW Grid Tied (GRO-GX60)",
        "root": "growcol-3-phase-60kw",
        "visible": true,
        "highlights": [
            {
                "id": 32,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 31,
                "label": "Rated Voltage",
                "value": "60kW"
            },
            {
                "id": 29,
                "label": "Inverter Type",
                "value": "Grid Tied Inverter"
            },
            {
                "id": 30,
                "label": "Input Voltage",
                "value": "1100V"
            }
        ],
        "overviews": [
            {
                "id": 8,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The Growcol 3 Phase 4 MPPT 60kW Grid Tied Inverter is a high-performance and advanced solar power solution designed to efficiently convert DC (direct current) electricity generated by solar panels into AC (alternating current) electricity for grid-connected applications. This inverter is an ideal choice for commercial and large-scale solar installations, offering reliable and optimised energy conversion.</div><div><br></div><h4>Key Features:</h4></div><div><br></div><div><ul><li>1. High Power Output: With a power output capacity of 60 kilowatts (kW), the Growcol inverter can handle substantial energy loads, making it suitable for large-scale solar projects, commercial buildings, and industrial applications.<br></li><li>2. Three-Phase Configuration: The inverter operates on a three-phase configuration, allowing it to efficiently handle and distribute power across multiple electrical phases. This feature enhances overall system stability and ensures reliable performance.<br></li><li>3. Multiple Maximum Power Point Tracking (MPPT): The Growcol inverter incorporates four MPPT trackers, enabling it to extract maximum power from solar panels, even in situations where the panels are subject to varying sunlight conditions or shading. This advanced MPPT technology ensures optimal energy harvesting and increased system efficiency.<br></li><li>4. Grid-Tied Functionality: The inverter seamlessly synchronises with the utility grid, allowing for the injection of surplus power generated by the solar panels. This enables users to offset their electricity consumption, reduce their energy bills, and potentially even earn revenue through feed-in tariffs or net metering schemes.<br></li><li>5. Robust and Durable Design: The Growcol inverter is built to withstand harsh environmental conditions. Its rugged construction and IP65-rated enclosure provide protection against dust, moisture, and other potential hazards, ensuring long-lasting performance in various outdoor settings.<br></li><li>6. Smart Monitoring and Communication: The inverter comes equipped with advanced monitoring and communication capabilities, allowing users to monitor the system's performance in real-time. It supports various communication protocols, including RS485, Modbus, and Ethernet, facilitating seamless integration with monitoring systems and enabling remote management and troubleshooting.<br></li><li>7. Easy Installation and Maintenance: The Growcol inverter features a user-friendly design that simplifies the installation process. It incorporates plug-and-play connectors and an intuitive interface, reducing the complexity and time required for setup. Additionally, the inverter's smart diagnostics and self-diagnosing capabilities aid in troubleshooting and maintenance, ensuring minimal downtime.<br></li><li>8. Compliance and Certifications: The Growcol 3 Phase 4 MPPT 60kW Grid Tied Inverter complies with international safety and quality standards, such as CE, UL, and IEC. These certifications validate its performance, reliability, and adherence to industry regulations.<br></li></ul><div><br></div></div><div>In summary, the Growcol 3 Phase 4 MPPT 60kW Grid Tied Inverter is a high-powered, efficient, and reliable solution for commercial and large-scale solar installations. With its advanced features, robust design, and seamless grid integration, this inverter offers enhanced energy generation, reduced electricity costs, and increased overall system performance.<br></div><div><br></div><div><br></div>"
            }
        ],
        "specifications": [
            {
                "id": 810,
                "label": "Parallel Operation",
                "value": "1"
            },
            {
                "id": 292,
                "label": "Max. Input Power",
                "value": "96kW"
            },
            {
                "id": 293,
                "label": "Max Input Voltage",
                "value": "1100V"
            },
            {
                "id": 296,
                "label": "Max. Apparent Power",
                "value": "66kVa"
            },
            {
                "id": 299,
                "label": "Environmental Temperature",
                "value": "-25°C ~ +60°C"
            },
            {
                "id": 295,
                "label": "Power Output",
                "value": "60kW"
            },
            {
                "id": 294,
                "label": "MPPT Voltage Range",
                "value": "200V ~ 1000V"
            },
            {
                "id": 297,
                "label": "Rated Grid Voltage",
                "value": "230Vac / 400Vac"
            },
            {
                "id": 300,
                "label": "Display",
                "value": "LED / LED + LCD / Wifi & App"
            },
            {
                "id": 301,
                "label": "Communication Interface",
                "value": "RS485 / USB"
            },
            {
                "id": 298,
                "label": "Max. Efficiency",
                "value": "98.80%"
            }
        ],
        "documents": [
            {
                "id": 19,
                "description": "Growcol-GX-50-70kW-Three-Phase-Grid-tied-Certificate-of-Conformity",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-GX-50-70kW-Three-Phase-Grid-tied-Certificate-of-Conformity.pdf"
            },
            {
                "id": 20,
                "description": "Growcol-GX-50-70kW-Three-Phase-Grid-tied-NRS-Certificate",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-GX-50-70kW-Three-Phase-Grid-tied-NRS-Certificate.pdf"
            },
            {
                "id": 18,
                "description": "Growcol-GX-50-70kW-Three-Phase-Grid-tied-Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-GX-50-70kW-Three-Phase-Grid-tied-Datasheet.pdf"
            },
            {
                "id": 21,
                "description": "Growcol-GX-50-70kW-Three-Phase-Grid-tied-ENS-Report",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-GX-50-70kW-Three-Phase-Grid-tied-ENS-Report.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 8,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol3-phase-4-mppt-60kw-grid-tied/",
                "code": "GRO-GX60",
                "sku": "GX60",
                "inventoryStatus": "INSTOCK",
                "cost": 46046.81,
                "markup": 0,
                "retail": 46046.81
            }
        ],
        "ratings": [
            {
                "id": 25,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 36,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 45,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 16,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 40,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-MPS0030",
        "name": "30kW Solar Storage",
        "longName": "Growcol 30kW Solar Storage Hybrid Inverter (GRO-MPS0030)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-MPS0030.png",
        "price": 131958.95,
        "category": "Inverters",
        "subCategory": "Hybrid",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 30kW Solar Storage Hybrid Inverter",
        "keywords": "Growcol, 30kW, Solar Storage, Hybrid Inverter, GRO-GW-MPS0030, GW-MPS0030, Solar, accredited installers, south africa, solar quotes, pv-panels, PV Panels, inverter, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, Gauteng, Limpopo, North West, Mpumalanga, Free State, Northern Cape, Western Cape, Eastern Cape, Kwazulu-Natal",
        "description": "Large-scale solar energy systems can be supported by inverters like the Growcol 30kW Solar Storage Hybrid Inverter. It has the ability to distribute and manage the power produced by a solar panel array while also storing any extra power in batteries for later use.",
        "root": "growcol-30kw-solar-storage",
        "visible": true,
        "highlights": [
            {
                "id": 34,
                "label": "Input Voltage",
                "value": "30kW"
            },
            {
                "id": 35,
                "label": "Rated Voltage",
                "value": "43V"
            },
            {
                "id": 33,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 36,
                "label": "Warranty",
                "value": "2 Years"
            }
        ],
        "overviews": [
            {
                "id": 9,
                "html": "<h4>Product Description</h4><div><br></div><div><div>Introducing the revolutionary Growcol 30kW Solar Storage Hybrid Inverter, the ultimate solution for efficient and sustainable energy management. Designed to harness the power of the sun, this cutting-edge inverter system allows you to maximise your solar energy utilisation and minimise your reliance on the grid.</div><div><br></div><div>The Growcol 30kW Solar Storage Hybrid Inverter combines the best of solar energy generation and energy storage technologies into one sleek and powerful unit. With its high-capacity 30kW output, it provides ample power to meet the energy demands of both residential and commercial applications. Whether you're powering your home, office, or a small business, this inverter has got you covered.</div><div><br></div><div>One of the standout features of the Growcol 30kW Solar Storage Hybrid Inverter is its advanced hybrid functionality. It seamlessly integrates solar power generation with battery storage, allowing you to store excess energy produced during the day for use during the night or during periods of low solar irradiation. This not only maximises self-consumption but also provides a reliable backup power source in the event of a grid outage.</div><div><br></div><div>Equipped with intelligent energy management algorithms, this inverter optimises the usage of solar energy and battery power, ensuring that your electricity needs are met efficiently. The built-in monitoring and control system provides real-time data on energy production, consumption, and storage, empowering you to make informed decisions about your energy usage.</div><div><br></div><div>Installation and setup of the Growcol 30kW Solar Storage Hybrid Inverter are straightforward, thanks to its user-friendly interface and comprehensive installation guide. Its compact design and wall-mountable configuration make it easy to integrate into your existing solar power system or install as a standalone unit.</div><div><br></div><div>Safety and reliability are of paramount importance with the Growcol 30kW Solar Storage Hybrid Inverter. It features multiple layers of protection, including overvoltage, overcurrent, and short-circuit protection, ensuring the longevity of the inverter and the safety of your electrical system.</div><div><br></div><div>Join the clean energy revolution and take control of your electricity consumption with the Growcol 30kW Solar Storage Hybrid Inverter. Experience the benefits of sustainable power generation, reduced energy costs, and increased energy independence. Upgrade your solar system today and unlock the true potential of renewable energy with Growcol.</div></div><div><br></div><div>The Growcol 30kW Solar Storage Hybrid Inverter is packed with advanced features to provide efficient and reliable energy management.&#160;</div><div><br></div><h4>Here are its key features:</h4><div><br></div><div><ul><li>1. High Power Output: With a 30kW capacity, this inverter is capable of handling the energy demands of both residential and commercial applications, ensuring ample power supply for your needs.<br></li><li>2. Solar Energy Integration: The inverter seamlessly integrates with solar power systems, allowing you to harness the sun's energy and convert it into usable electricity. This maximises your solar energy utilisation and reduces your reliance on the grid.<br></li><li>3. Battery Storage: The hybrid functionality of the Growcol inverter enables you to store excess solar energy in batteries for later use. This ensures you have a reliable backup power source during grid outages or periods of low solar irradiation.<br></li><li>4. Intelligent Energy Management: Equipped with advanced algorithms, the inverter optimises the usage of solar energy and battery power, intelligently distributing and prioritising electricity consumption for maximum efficiency.<br></li><li>5. Real-time Monitoring and Control: The built-in monitoring system provides real-time data on energy production, consumption, and storage. This allows you to track and analyze your energy usage, empowering you to make informed decisions about energy management.<br></li><li>6. Easy Installation and Setup: The Growcol inverter is designed for easy installation and setup. Its user-friendly interface and comprehensive installation guide make the process hassle-free, whether you're integrating it into an existing solar system or installing it as a standalone unit.<br></li><li>7. Compact and Wall-Mountable Design: The inverter's compact design and wall-mountable configuration make it space-efficient and easy to install in various locations, ensuring flexibility and adaptability to your specific requirements.<br></li><li>8. Safety Features: The Growcol inverter prioritises safety with multiple layers of protection, including overvoltage, overcurrent, and short-circuit protection. These safety measures ensure the longevity of the inverter and safeguard your electrical system.<br></li></ul><div><br></div></div><div>Upgrade your energy management capabilities with the Growcol 30kW Solar Storage Hybrid Inverter, and enjoy the benefits of efficient solar energy utilisation, reliable backup power, and increased control over your electricity consumption.<br></div>"
            }
        ],
        "specifications": [
            {
                "id": 811,
                "label": "Parallel Operation",
                "value": "4"
            },
            {
                "id": 302,
                "label": "Power Output",
                "value": "30kW"
            },
            {
                "id": 305,
                "label": "Max. PV Power",
                "value": "60/120kW"
            },
            {
                "id": 307,
                "label": "Dimensions (W x D x H)",
                "value": "800x800x1900mm"
            },
            {
                "id": 308,
                "label": "Weight",
                "value": "440kg"
            },
            {
                "id": 306,
                "label": "PV MPPT Voltage Range",
                "value": "200V - 850V"
            },
            {
                "id": 303,
                "label": "Voltage Range",
                "value": "320V - 460V"
            },
            {
                "id": 310,
                "label": "Communication Interface",
                "value": "RS485/CAN"
            },
            {
                "id": 309,
                "label": "Environmental Temperature",
                "value": "-25°C ~ +55°C"
            },
            {
                "id": 311,
                "label": "Display",
                "value": "Touch Screen LCD"
            },
            {
                "id": 304,
                "label": "Max. PV Open-Circuit Voltage",
                "value": "1000VDC"
            }
        ],
        "documents": [
            {
                "id": 22,
                "description": "GRO-GW-MPS0030-MPS User Manual",
                "url": "https://www.solarcentral.co.za/pdf/GRO-GW-MPS0030-MPS-User-Manual.pdf"
            },
            {
                "id": 23,
                "description": "GRO-GW-MPS0030 MPS Range",
                "url": "https://www.solarcentral.co.za/pdf/GRO-GW-MPS0030-MPS-Range.pdf"
            },
            {
                "id": 24,
                "description": "GRO-GW-MPS0030 Growcol Warranty Card",
                "url": "https://www.solarcentral.co.za/pdf/GRO-GW-MPS0030-Growcol-Warranty-Card.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 9,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol30kw-solar-storage-hybrid-inverter/",
                "code": "GRO-MPS0030",
                "sku": "GW-MPS0030",
                "inventoryStatus": "LOWSTOCK",
                "cost": 131958.95,
                "markup": 0,
                "retail": 131958.95
            }
        ],
        "ratings": [
            {
                "id": 31,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 4,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 23,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 8,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 41,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-MPS0500",
        "name": "500kW Solar Storage",
        "longName": "Growcol 500kW Solar Storage Hybrid Inverter (GRO-MPS0500)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-MPS0500.png",
        "price": 91798.69,
        "category": "Inverters",
        "subCategory": "Hybrid",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 500kW Solar Storage Hybrid Inverter",
        "keywords": "growcol, 500kW, solar storage, hybrid inverter, MPS0030, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal",
        "description": "Large-scale solar energy systems can be supported by inverters of the Growcol 500kW Solar Storage Hybrid variety. It has the ability to control and distribute power produced by a solar array while also storing extra power in batteries for later use.",
        "root": "growcol-500kw-solar-storage",
        "visible": true,
        "highlights": [
            {
                "id": 39,
                "label": "Rated Current",
                "value": "722A"
            },
            {
                "id": 40,
                "label": "Warranty",
                "value": "2 Years"
            },
            {
                "id": 38,
                "label": "Input Voltage",
                "value": "500V"
            },
            {
                "id": 37,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            }
        ],
        "overviews": [
            {
                "id": 10,
                "html": "<h4>Product Description</h4><div><div><br></div><div>The Growcol 500kW Solar Storage Hybrid Inverter is an advanced energy management solution designed for large-scale solar power systems.&#160;</div><div><br></div><h4>Here are some key features of this inverter:</h4></div><div><br></div><div><ul><li>1. High Power Capacity: The Growcol 500kW Solar Storage Hybrid Inverter is capable of handling large-scale solar installations with its 500 kilowatt (kW) power capacity. This makes it suitable for commercial and industrial applications where high power demands are present.<br></li><li>2. Solar Integration: The inverter seamlessly integrates with solar photovoltaic (PV) arrays, allowing for efficient harvesting and utilisation of solar energy. It maximises the conversion of solar power into usable electricity, optimising energy production from the installed solar panels.<br></li><li>3. Battery Storage Capability: One of the standout features of the Growcol 500kW Hybrid Inverter is its integrated battery storage capability. It allows for the connection of energy storage systems, such as lithium-ion batteries, enabling the storage of excess solar energy for later use. This feature enhances self-consumption and enables energy independence even during periods of low solar generation or during power outages.<br></li><li>4. Hybrid Operation: The inverter supports hybrid operation, combining energy from multiple sources, including solar power, battery storage, and the grid. It intelligently manages the energy flow, prioritising solar and battery power usage to reduce dependency on the grid. This feature helps in reducing electricity bills and optimising energy usage.<br></li><li>5. Grid-Tied Functionality: The Growcol 500kW Hybrid Inverter can be connected to the electrical grid, allowing for the export of excess energy back to the grid. It facilitates net metering or feed-in tariff programs, enabling users to earn credits for the electricity they feed into the grid. This feature enhances the overall economic viability of the solar power system.<br></li><li>6. Monitoring and Control: The inverter is equipped with advanced monitoring and control capabilities. It provides real-time monitoring of energy production, battery status, and system performance. Users can access this information remotely through a user-friendly interface, allowing for effective system management and troubleshooting.<br></li><li>7. Scalability and Flexibility: The Growcol 500kW Hybrid Inverter offers scalability, allowing for the expansion of the solar power system as per the user's requirements. It can accommodate additional solar panels or batteries, providing flexibility to adapt to changing energy needs over time.<br></li><li>8. Grid Support Functions: The inverter incorporates grid support functions, such as reactive power control and voltage regulation. These features contribute to grid stability and enable seamless integration with utility grids.<br></li></ul><div><br></div></div><div>Overall, the Growcol 500kW Solar Storage Hybrid Inverter offers a powerful and versatile solution for large-scale solar power systems, combining solar integration, battery storage, and grid-tied functionality. It enables efficient energy management, enhances self-consumption, and maximises the economic benefits of solar energy.<br></div>"
            }
        ],
        "specifications": [
            {
                "id": 315,
                "label": "Max. PV Open-Circuit Voltage",
                "value": "1000VDC"
            },
            {
                "id": 319,
                "label": "Environmental Temperature",
                "value": "-25°C ~ +55°C"
            },
            {
                "id": 320,
                "label": "Display",
                "value": "Touch Screen LCD"
            },
            {
                "id": 321,
                "label": "Communication Interface",
                "value": "RS485/CAN"
            },
            {
                "id": 318,
                "label": "Battery Voltage Range",
                "value": "500V - 850V"
            },
            {
                "id": 812,
                "label": "Parallel Operation",
                "value": "4"
            },
            {
                "id": 317,
                "label": "PV MPPT Voltage Range",
                "value": "200V - 850V"
            },
            {
                "id": 316,
                "label": "Max. PV Power",
                "value": "600/660/720kW"
            },
            {
                "id": 312,
                "label": "Power Output",
                "value": "500kW"
            },
            {
                "id": 314,
                "label": "Voltage Range",
                "value": "320V - 460V"
            },
            {
                "id": 313,
                "label": "Rated Voltage",
                "value": "400V"
            }
        ],
        "documents": [
            {
                "id": 26,
                "description": "MPS User Manual",
                "url": "https://www.solarcentral.co.za/pdf/MPS0500-MPS-User-Manual.pdf"
            },
            {
                "id": 25,
                "description": "MPS Range",
                "url": "https://www.solarcentral.co.za/pdf/MPS0500-MPS-Range.pdf"
            },
            {
                "id": 27,
                "description": "Growcol Commercial Inverter MPS-TUV-Certificate",
                "url": "https://www.solarcentral.co.za/pdf/MPS0500-Growcol-Commercial-Inverter-MPS-TUV-Certificate-AK50573567_0001.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 10,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol500kw-solar-storage-hybrid-inverter/",
                "code": "GRO-MPS0500",
                "sku": "GW-MPS0500",
                "inventoryStatus": "SOLDOUT",
                "cost": 91798.69,
                "markup": 0,
                "retail": 91798.69
            }
        ],
        "ratings": [
            {
                "id": 40,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 53,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 35,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 38,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 42,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-MPS0050",
        "name": "50kW Solar Storage",
        "longName": "Growcol 50kW Solar Storage Hybrid Inverter (GRO-MPS0050)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-MPS0050.png",
        "price": 252119.04,
        "category": "Inverters",
        "subCategory": "Hybrid",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol 50kW Solar Storage Hybrid Inverter",
        "keywords": "growcol, 500kW, solar storage, hybrid inverter, MPS0030, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, Growcol,50kW,Solar,Storage,Hybrid,Inverter",
        "description": "Sample description",
        "root": "growcol-50kw-solar-storage",
        "visible": true,
        "highlights": [
            {
                "id": 42,
                "label": "Input Voltage",
                "value": "50kW"
            },
            {
                "id": 41,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 43,
                "label": "Rated Current",
                "value": "72A"
            },
            {
                "id": 44,
                "label": "Warranty",
                "value": "2 Years"
            }
        ],
        "overviews": [
            {
                "id": 11,
                "html": "<h4>Product Description</h4><div><br></div>The Growcol 50kW Solar Storage Hybrid Inverter is a cutting-edge solution designed to maximise the efficiency and sustainability of solar energy systems. This advanced inverter combines the benefits of solar power generation and energy storage, allowing users to harness and store clean energy for later use.<div><br></div><h4>Here are its key features:</h4><div><br></div><div><ul><li>1. High Power Output: With a capacity of 50kW, this solar storage hybrid inverter is capable of handling large-scale energy requirements, making it suitable for commercial and industrial applications. It ensures a stable and reliable power output, enabling seamless integration with existing energy systems.<br></li><li>2. Solar Energy Integration: The Growcol inverter efficiently converts solar energy into electricity, minimising energy loss and maximising the utilisation of renewable resources. By leveraging the power of the sun, users can significantly reduce their dependence on conventional energy sources, resulting in lower electricity bills and a smaller carbon footprint.<br></li><li>3. Energy Storage Capability: The hybrid inverter incorporates advanced energy storage technology, allowing users to store surplus solar energy for later use. This feature ensures a consistent power supply even during periods of low sunlight or grid outages. By intelligently managing energy flow, the inverter optimises self-consumption and reduces reliance on the electrical grid.<br></li><li>4. Grid-Tied Functionality: The inverter supports grid-tied functionality, enabling seamless integration with the existing power grid. It allows users to sell excess solar power back to the grid, promoting energy sharing and potentially generating additional income. This feature also ensures a reliable power supply by automatically switching to grid power during peak demand or when solar energy is insufficient.<br></li><li>5. Smart Energy Management: The Growcol 50kW Solar Storage Hybrid Inverter incorporates intelligent energy management features. It utilises advanced algorithms to monitor energy consumption patterns, optimise energy usage, and prioritise the most efficient power sources. The user-friendly interface provides real-time data and analytics, allowing users to track energy generation, storage, and usage for better energy management.<br></li><li>6. Enhanced Durability and Safety: This solar storage hybrid inverter is built with high-quality components and adheres to stringent safety standards. It features overvoltage protection, short circuit protection, and thermal management systems to safeguard against electrical hazards and ensure long-lasting performance.<br></li></ul><div><br></div><div>In summary, the Growcol 50kW Solar Storage Hybrid Inverter offers a reliable and efficient solution for harnessing solar power and storing excess energy. With its high power output, energy storage capability, grid-tied functionality, and intelligent energy management features, it empowers users to reduce their reliance on traditional energy sources and embrace a sustainable, cost-effective energy future.<br></div></div><div><br></div><div><br></div>"
            }
        ],
        "specifications": [
            {
                "id": 325,
                "label": "Environmental Temperature",
                "value": "-25°C ~ +55°C"
            },
            {
                "id": 323,
                "label": "Max. PV Open-Circuit Voltage",
                "value": "1000VDC"
            },
            {
                "id": 330,
                "label": "Dimensions (W x D x H)",
                "value": "800x800x1900mm"
            },
            {
                "id": 331,
                "label": "Weight",
                "value": "440kg"
            },
            {
                "id": 328,
                "label": "Power Output",
                "value": "50kW"
            },
            {
                "id": 324,
                "label": "PV MPPT Voltage Range",
                "value": "200V - 850V"
            },
            {
                "id": 329,
                "label": "Max. PV Power",
                "value": "60/120kW"
            },
            {
                "id": 326,
                "label": "Communication Interface",
                "value": "RS485/CAN"
            },
            {
                "id": 322,
                "label": "Voltage Range",
                "value": "320V - 460V"
            },
            {
                "id": 327,
                "label": "Display",
                "value": "Touch Screen LCD"
            },
            {
                "id": 813,
                "label": "Parallel Operation",
                "value": "4"
            }
        ],
        "documents": [
            {
                "id": 28,
                "description": "MPS Range",
                "url": "https://www.solarcentral.co.za/pdf/MPS0050-MPS-Range.pdf"
            },
            {
                "id": 29,
                "description": "MPS User Manual",
                "url": "https://www.solarcentral.co.za/pdf/MPS0050-MPS-User-Manual.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 11,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol50kw-solar-storage-hybrid-inverter/",
                "code": "GRO-MPS0050",
                "sku": "GW-MPS0050",
                "inventoryStatus": "LOWSTOCK",
                "cost": 252119.04,
                "markup": 0,
                "retail": 252119.04
            }
        ],
        "ratings": [
            {
                "id": 24,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 9,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 43,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 12,
                "type": "Ease of Use",
                "rating": 4
            }
        ]
    },
    {
        "id": 20,
        "uid": "c6c6d818-e917-11ed-94cd-5b7221171867",
        "code": "GRO-SPF5000-ES",
        "name": "5kW Inverter 48V + Wifi",
        "longName": "Growatt 5kW Output Solar Off-grid Inverter (SPF5000-ES)",
        "brand": "Growatt",
        "image": "https://www.solarcentral.co.za/images/GRO-SPF5000-ES.png",
        "price": 13455,
        "category": "Inverters",
        "subCategory": "Grid-Tied, Residential",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growatt 5kW Output Solar Off-grid Inverter SPF5000-ES",
        "keywords": "Growatt 5kW Output Solar Off-grid Inverter SPF5000-ES, SPF5000ES, Error 19, spf5000es specs, 5000ES User Manual, 5Kw 48V SPF 5000 ES Datasheet, hybrid inverter, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal",
        "description": "The Growatt SPF5000-ES is a solar off-grid inverter manufactured by Growatt, a well-known company in the solar power industry. This particular model has a 5 kW output capacity, which means it can handle a maximum power output of 5,000 watts.",
        "root": "growatt-5kw-off-grid",
        "visible": true,
        "highlights": [
            {
                "id": 4,
                "label": "Warranty",
                "value": "2 Years"
            },
            {
                "id": 1,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 2,
                "label": "Input Power",
                "value": "5000W"
            },
            {
                "id": 3,
                "label": "Max AC Power",
                "value": "230VAC"
            }
        ],
        "overviews": [
            {
                "id": 1,
                "html": "<p>The well-known solar power manufacturer Growatt produces the Growatt SPF5000-ES solar off-grid converter. The highest power output for this particular model, which has a 5 kW output capacity, is 5,000 watts.</p><p>An autonomous power system without a connection to the utility grid can be built using solar panels, batteries, and an off-grid inverter like the SPF5000-ES. It changes the solar panels' direct current (DC) electricity into alternating current (AC), which can be used to run electrical loads like as home appliances.</p><p><strong>Key features of the Growatt SPF5000-ES include:</strong></p><ul><li>1. Pure Sine Wave Output: The inverter produces a pure sine wave AC output, which is the same high-quality power that comes from the utility grid. This ensures compatibility with a wide range of appliances and minimizes the risk of damage to sensitive electronics.</li><li>2. Built-in MPPT Charge Controller: The inverter integrates a maximum power point tracking (MPPT) charge controller, which optimizes the energy harvested from the solar panels. It efficiently converts the solar energy into electrical power and charges the connected battery bank.</li><li>3. Battery Management: The inverter incorporates battery management functions to ensure the optimal performance and longevity of the connected battery system. It supports different battery types, such as lead-acid and lithium-ion batteries, and provides various charging modes to cater to specific battery requirements.</li><li>4. LCD Display and Monitoring: The inverter is equipped with an LCD display that provides real-time information about system status, including solar input power, battery voltage, AC output voltage, and more. This allows users to monitor the performance of their solar power system.</li><li>5. Multiple Protection Mechanisms: The SPF5000-ES includes comprehensive protection features to safeguard the inverter, battery, and connected devices. These protections typically include overvoltage protection, overcurrent protection, short circuit protection, temperature protection, and more.</li></ul><p>It's important to note that specific features and functionalities may vary depending on the exact model and firmware version of the Growatt SPF5000-ES inverter. It's always recommended to refer to the product documentation or contact Growatt directly for detailed specifications and any specific questions you may have.</p>"
            }
        ],
        "specifications": [
            {
                "id": 173,
                "label": "Power Output",
                "value": "5kW"
            },
            {
                "id": 176,
                "label": "Surge Power",
                "value": "10000W"
            },
            {
                "id": 178,
                "label": "MPPT Range @ Operating Voltage",
                "value": "120VDC ~ 430VDC"
            },
            {
                "id": 180,
                "label": "Max. Solar Charge Current",
                "value": "100A"
            },
            {
                "id": 174,
                "label": "Parallel Operation",
                "value": "6"
            },
            {
                "id": 179,
                "label": "Max. PV Array Open Circuit Voltage",
                "value": "450VDC"
            },
            {
                "id": 181,
                "label": "AC Input Voltage",
                "value": "230VAC"
            },
            {
                "id": 175,
                "label": "AC Voltage Regulation",
                "value": "230VAC (+)- 5% @ 50/60Hz"
            },
            {
                "id": 177,
                "label": "Max. PV Array Input",
                "value": "6000W"
            },
            {
                "id": 182,
                "label": "Selectable Voltage Range",
                "value": "90 - 280 VAC"
            }
        ],
        "documents": [
            {
                "id": 1,
                "description": "5Kw 48V Growatt SPF 5000 ES Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/5Kw-48V-Growatt-SPF-5000-ES-datasheet.pdf"
            },
            {
                "id": 2,
                "description": "Growatt 5000ES User Manual",
                "url": "https://www.solarcentral.co.za/pdf/growatt-5000es.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 1,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growatt-5000es-pro/",
                "code": "GRO-SPF5000-ES",
                "sku": "GROWATT ES-PRO",
                "inventoryStatus": "LOWSTOCK",
                "cost": 13455,
                "markup": 0,
                "retail": 13455
            }
        ],
        "ratings": [
            {
                "id": 6,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 15,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 29,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 48,
                "type": "Ease of Use",
                "rating": 4
            }
        ]
    },
    {
        "id": 9,
        "uid": "1fa29cee-f180-11ee-aeca-4e2528fc3ca0",
        "code": "SS-1P-05K-H-LV",
        "name": "5kW Inverter 48V + Wifi",
        "longName": "Sunsynk 5kW 1P Hybrid PV Inverter 48v C/W Wifi Dongle IP65",
        "brand": "Sunsynk",
        "image": "https://www.solarcentral.co.za/images/SS-1P-05K-H-LV.png",
        "price": 0,
        "category": "Inverters",
        "subCategory": "Residential, Hybrid",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Sunsynk 5kW Hybrid Inverter",
        "keywords": "Sunsynk, 5kW, Hybrid Inverter, 48v, Inverter, Inverters, Residential, Hybrid",
        "description": "Sunsynk 5kW 1P Hybrid PV Inverter 48v C/W Wifi Dongle IP65",
        "root": "sunsynk-5kw-48v-wifi",
        "visible": true,
        "highlights": [
            {
                "id": 277,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 278,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 279,
                "label": "Max AC Power",
                "value": "10,000W (2x Rated)"
            },
            {
                "id": 276,
                "label": "Input Power",
                "value": "5,000W"
            }
        ],
        "overviews": [
            {
                "id": 81,
                "html": "<div>The SynSynk 5kW Single Phase Hybrid Inverter is a cutting-edge energy management system designed to maximise efficiency and optimise power usage in residential or small commercial settings. Combining the functionalities of a solar inverter, battery charger, and grid-tie inverter, the SynSynk offers a comprehensive solution for users seeking to harness renewable energy sources while ensuring reliable power supply.</div><div><br></div><div>Key features of the SynSynk 5kW Single Phase Hybrid Inverter include:</div><div><br></div><div>1. <b>High Efficiency</b>: The inverter is engineered to deliver high conversion efficiency, ensuring minimal energy loss during power conversion processes. This efficiency translates to greater energy savings and reduced electricity bills for users.</div><div><br></div><div>2. <b>Hybrid Functionality</b>: By seamlessly integrating solar energy, battery storage, and grid power, the SynSynk enables users to optimise energy usage based on their specific needs and available resources. This hybrid functionality allows for increased self-consumption of solar power and provides backup power during grid outages.</div><div><br></div><div>3. <b>Scalability</b>: The inverter system is designed to be scalable, allowing users to easily expand their solar photovoltaic (PV) array or battery storage capacity as their energy requirements grow over time. This flexibility ensures that the system can adapt to changing energy needs and evolving technological advancements.</div><div><br></div><div>4. <b>Remote Monitoring and Control</b>: Users can conveniently monitor and control the SynSynk inverter system remotely via a dedicated mobile app or web-based interface. This feature provides real-time insights into energy production, consumption, and battery status, allowing for proactive management and optimisation of energy resources.</div><div><br></div><div>5. <b>Advanced Protection Mechanisms</b>: The SynSynk inverter incorporates advanced safety features to protect against overvoltage, overcurrent, short circuits, and other electrical faults. These protection mechanisms ensure safe and reliable operation of the system, safeguarding both the equipment and the connected electrical infrastructure.</div><div><br></div><div>6. <b>User-friendly Interface</b>: The inverter is equipped with an intuitive user interface, featuring a clear display and easy-to-navigate menus. This user-friendly design simplifies installation, configuration, and maintenance tasks, making the SynSynk accessible to both professional installers and end-users alike.</div><div><br></div><div>Overall, the SynSynk 5kW Single Phase Hybrid Inverter offers a comprehensive solution for optimising energy management and maximising the benefits of renewable energy sources in residential and small commercial applications. With its high efficiency, hybrid functionality, scalability, and advanced features, the SynSynk represents a versatile and reliable choice for sustainable energy solutions.</div>"
            }
        ],
        "specifications": [
            {
                "id": 792,
                "label": "Grid Connection",
                "value": "Single phase, 230V AC"
            },
            {
                "id": 788,
                "label": "Maximum Efficiency",
                "value": "Up to 97%"
            },
            {
                "id": 816,
                "label": "Parallel Operation",
                "value": "6"
            },
            {
                "id": 794,
                "label": "Protection",
                "value": "Overvoltage, overcurrent, short circuit, overtemperature, etc."
            },
            {
                "id": 787,
                "label": "Maximum PV Input Voltage",
                "value": "600V (DC)"
            },
            {
                "id": 789,
                "label": "Battery Voltage Range",
                "value": "48V (DC)"
            },
            {
                "id": 790,
                "label": "Nominal Output Voltage",
                "value": "230V (AC)"
            },
            {
                "id": 786,
                "label": "Input Voltage Range",
                "value": "90V - 550V (DC) for PV input, 230V (AC) for grid input"
            },
            {
                "id": 791,
                "label": "Frequency",
                "value": "50 Hz or 60 Hz"
            },
            {
                "id": 785,
                "label": "Power Output",
                "value": "5kW"
            },
            {
                "id": 793,
                "label": "Operating Temperature Range",
                "value": "-20°C to 60°C (-4°F to 140°F)"
            }
        ],
        "documents": [
            {
                "id": 118,
                "description": "Installation Manual",
                "url": "https://www.solarcentral.co.za/pdf/Sunsynk-5.5kW-Installer-Manual.pdf"
            },
            {
                "id": 119,
                "description": "User Manual",
                "url": "https://www.solarcentral.co.za/pdf/Sunsynk-5.5kW-User-manual.pdf"
            },
            {
                "id": 117,
                "description": "Specification Sheet",
                "url": "https://www.solarcentral.co.za/pdf/Sunsynk-5.5kW.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 77,
                "distributor": "Herholdts",
                "distributorClient": "za.co.visualage.inventory.distributor.HerholdtsDistributorClient",
                "refreshUrl": "https://herholdts.co.za/pi64351/sunsynk-5kw-1p-hybrid-pv-inverter-48v-c-w-wifi-dongle-ip65/",
                "code": "SS-1P-05K-H-LV",
                "sku": "SS-1P-05K-H-LV",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.14,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 3,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 22,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 51,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 54,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 10,
        "uid": "fa9acb26-f60f-11ee-80f3-ff71116d7caf",
        "code": "SS-1P-08K-H-LV",
        "name": "8kW Inverter 48V + Wifi",
        "longName": "Sunsynk 8kW 1P Hybrid PV Inverter 48v C/W Wifi Dongle IP65",
        "brand": "Sunsynk",
        "image": "https://www.solarcentral.co.za/images/SS-1P-08K-H-LV.png",
        "price": 29865.5,
        "category": "Inverters",
        "subCategory": "Residential, Hybrid",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Sunsynk 8kW Hybrid Inverter",
        "keywords": "Sunsynk, 8kW, Hybrid Inverter, 48v, Inverter, Inverters, Residential, Hybrid",
        "description": "The Sunsynk 8kW 1P Hybrid PV Inverter 48V with Wi-Fi Dongle and IP65 rating excels in efficient power management. It seamlessly integrates solar, grid, and generator sources, supports dual MPPT, and offers smart monitoring, making it ideal for residential and commercial energy solutions.",
        "root": "sunsynk-8kw-48v-wifi",
        "visible": true,
        "highlights": [
            {
                "id": 283,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 284,
                "label": "Max AC Power",
                "value": "8,800W"
            },
            {
                "id": 282,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 281,
                "label": "Output and UPS Power",
                "value": "8,000W"
            }
        ],
        "overviews": [
            {
                "id": 82,
                "html": "<div>The SynSynk 8.8kW Single Phase Hybrid Inverter is a cutting-edge energy management system designed to maximise efficiency and optimise power usage in residential or small commercial settings. Combining the functionalities of a solar inverter, battery charger, and grid-tie inverter, the SynSynk offers a comprehensive solution for users seeking to harness renewable energy sources while ensuring reliable power supply.</div><div><br></div><div>Key features of the SynSynk 8.8kW Single Phase Hybrid Inverter include:</div><div><br></div><div>1.&#160;<span>High Efficiency</span>: The inverter is engineered to deliver high conversion efficiency, ensuring minimal energy loss during power conversion processes. This efficiency translates to greater energy savings and reduced electricity bills for users.</div><div><br></div><div>2.&#160;<span>Hybrid Functionality</span>: By seamlessly integrating solar energy, battery storage, and grid power, the SynSynk enables users to optimise energy usage based on their specific needs and available resources. This hybrid functionality allows for increased self-consumption of solar power and provides backup power during grid outages.</div><div><br></div><div>3.&#160;<span>Scalability</span>: The inverter system is designed to be scalable, allowing users to easily expand their solar photovoltaic (PV) array or battery storage capacity as their energy requirements grow over time. This flexibility ensures that the system can adapt to changing energy needs and evolving technological advancements.</div><div><br></div><div>4.&#160;<span>Remote Monitoring and Control</span>: Users can conveniently monitor and control the SynSynk inverter system remotely via a dedicated mobile app or web-based interface. This feature provides real-time insights into energy production, consumption, and battery status, allowing for proactive management and optimisation of energy resources.</div><div><br></div><div>5.&#160;<span>Advanced Protection Mechanisms</span>: The SynSynk inverter incorporates advanced safety features to protect against overvoltage, overcurrent, short circuits, and other electrical faults. These protection mechanisms ensure safe and reliable operation of the system, safeguarding both the equipment and the connected electrical infrastructure.</div><div><br></div><div>6.&#160;<span>User-friendly Interface</span>: The inverter is equipped with an intuitive user interface, featuring a clear display and easy-to-navigate menus. This user-friendly design simplifies installation, configuration, and maintenance tasks, making the SynSynk accessible to both professional installers and end-users alike.</div><div><br></div><div>Overall, the SynSynk 8.8kW Single Phase Hybrid Inverter offers a comprehensive solution for optimising energy management and maximising the benefits of renewable energy sources in residential and small commercial applications. With its high efficiency, hybrid functionality, scalability, and advanced features, the SynSynk represents a versatile and reliable choice for sustainable energy solutions.</div>"
            }
        ],
        "specifications": [
            {
                "id": 796,
                "label": "Input Voltage Range",
                "value": "450 V - 900 V DC (PV), 220 V AC"
            },
            {
                "id": 799,
                "label": "Battery Voltage Range",
                "value": "48V (DC)"
            },
            {
                "id": 817,
                "label": "Parallel Operation",
                "value": "6"
            },
            {
                "id": 801,
                "label": "Frequency",
                "value": "50 Hz or 60 Hz"
            },
            {
                "id": 803,
                "label": "Operating Temperature Range",
                "value": "-20°C to 60°C (-4°F to 140°F)"
            },
            {
                "id": 800,
                "label": "Nominal Output Voltage",
                "value": "230V (AC)"
            },
            {
                "id": 797,
                "label": "Maximum PV Input Voltage",
                "value": "1000 V DC"
            },
            {
                "id": 795,
                "label": "Power Output",
                "value": "8kW"
            },
            {
                "id": 804,
                "label": "Protection",
                "value": "Overvoltage, overcurrent, short circuit, overtemperature, etc."
            },
            {
                "id": 802,
                "label": "Grid Connection",
                "value": "Single phase, 230V AC"
            },
            {
                "id": 798,
                "label": "Maximum Efficiency",
                "value": "Up to 97%"
            }
        ],
        "documents": [
            {
                "id": 121,
                "description": "Installation Manual",
                "url": "https://www.solarcentral.co.za/pdf/sunsynk-8.8kw-installer-manual-1.pdf"
            },
            {
                "id": 122,
                "description": "User Manual",
                "url": "https://www.solarcentral.co.za/pdf/sunsynk-8.8kw-user-manual-1.pdf"
            },
            {
                "id": 120,
                "description": "Sunsynk Hybrid Inverter 8kW Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Sunsynk_Hybrid_Inverter_8kW_Datasheet.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 78,
                "distributor": "Herholdts",
                "distributorClient": "za.co.visualage.inventory.distributor.HerholdtsDistributorClient",
                "refreshUrl": "https://herholdts.co.za/pi68143/sunsynk%2D8kw%2D1p%2Dhybrid%2Dpv%2Dinverter%2D48v%2Dc%2Dw%2Dwifi%2Ddongle%2Dip65/",
                "code": "SS-1P-08K-H-LV",
                "sku": "SS-1P-08K-H-LV",
                "inventoryStatus": "INSTOCK",
                "cost": 27653.24,
                "markup": 0.08,
                "retail": 29865.5
            }
        ],
        "ratings": [
            {
                "id": 33,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 44,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 10,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 32,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 35,
        "uid": "a022209a-126c-11ee-be56-0242ac120002",
        "code": "GRO-R8KL1",
        "name": "8kW Inverter 48V + Wifi",
        "longName": "Growcol Hybrid Inverter 8Kw 48V + WIFI (GRO-R8KL1)",
        "brand": "Growcol",
        "image": "https://www.solarcentral.co.za/images/GRO-R8KL1.png",
        "price": 32200,
        "category": "Inverters",
        "subCategory": "Hybrid",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Growcol Hybrid Inverter 8Kw 48V + WIFI",
        "keywords": "Growcol Hybrid Inverter 8Kw 48V, WIFI",
        "description": "The GROWCOL 1P Hybrid Inverter 8Kw 48V + WIFI is an apparatus made to manage and regulate the energy flow in a solar power system. It is a hybrid inverter, which enables it to both transform DC electricity from solar panels into AC power for use in your home or place of business and also charge a battery bank with extra solar energy for later use. According to its 8Kw rating, the inverter can handle up to 8,000 watts of AC power, which is its maximum power output. The battery bank's DC voltage that the inverter may charge is specified by the 48V rating.",
        "root": "growcol-8kw-48v-wifi",
        "visible": true,
        "highlights": [
            {
                "id": 15,
                "label": "Input Voltage (kW)",
                "value": "12"
            },
            {
                "id": 13,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 14,
                "label": "Inverter Type",
                "value": "Hybrid Inverter"
            },
            {
                "id": 16,
                "label": "Rated Voltage (V)",
                "value": "220V – 230V – 240V"
            }
        ],
        "overviews": [
            {
                "id": 4,
                "html": "<div>The Growcol 1P Hybrid Inverter 8Kw 48V + WIFI is an apparatus made to manage and regulate the energy flow in a solar power system. It is a hybrid inverter, which enables it to both transform DC electricity from solar panels into AC power for use in your home or place of business and also charge a battery bank with extra solar energy for later use.</div><div><br></div><div>According to its 8Kw rating, the inverter can handle up to 8,000 watts of AC power, which is its maximum power output. The battery bank's DC voltage that the inverter may charge is specified by the 48V rating.</div><div><br></div><div><div>The Growcol 1P Hybrid Inverter 8Kw 48V with WIFI is an advanced power management device designed for renewable energy systems, particularly solar power systems. It combines the functionality of a hybrid inverter with built-in WIFI connectivity, providing users with greater control and monitoring capabilities over their energy production and consumption.</div><div><br></div><div>The inverter has a power output of 8Kw, making it suitable for medium to large-scale residential or commercial installations. It operates at a voltage of 48V, which is commonly used in solar power systems and ensures compatibility with a wide range of solar panels and batteries.</div><div><br></div><div>One of the key features of the Growcol 1P Hybrid Inverter is its hybrid functionality. It supports both grid-tie and off-grid operation, allowing users to seamlessly switch between different power sources. In grid-tie mode, the inverter can feed excess electricity back into the grid, enabling users to earn credits or reduce their electricity bills. In off-grid mode, it can provide power during outages or in areas without access to the grid, ensuring uninterrupted electricity supply.</div><div><br></div><div>The inclusion of WIFI connectivity sets the Growcol 1P Hybrid Inverter apart from traditional inverters. By connecting the inverter to a local WIFI network, users can access real-time data and control the system remotely through a dedicated mobile application or web interface. This feature enables users to monitor energy production, track energy consumption, and adjust system settings from anywhere, enhancing convenience and optimising energy management.</div><div><br></div><div>Additionally, the Growcol 1P Hybrid Inverter incorporates advanced safety mechanisms and protection features. It is equipped with overvoltage, overcurrent, and overheating protection to safeguard the inverter and connected devices. The inverter also offers multiple operating modes, including battery priority, PV priority, and hybrid mode, allowing users to customise their system's performance based on their specific requirements.</div><div><br></div><div>In summary, the Growcol 1P Hybrid Inverter 8Kw 48V with WIFI combines the functionalities of a hybrid inverter and WIFI connectivity to provide users with efficient and convenient control over their solar power systems. With its high power output, versatile operating modes, and advanced safety features, it is a reliable and user-friendly solution for maximising energy production and consumption in residential and commercial settings.</div></div><div><br></div><div><div>Overall, the GROWCOL 1P Hybrid Inverter 8Kw 48V + WIFI is a high-quality and versatile device that can help you to maximize the energy efficiency of your solar power system.</div><div><br></div><div><b>Elegant</b></div></div><div><ul><li>1. Fashionable appearance, lightweight, smart operation.<br></li><li>2. Natural cooling, low noise.<br></li><li>3. IP65 , wall-mounted design, saving space.<br></li><li>4. Touch screen LCD.<br></li></ul><div><b>Reliable</b><br></div></div><div><ul><li>Compatible anti-counter flow function.<br></li><li>Battery reverse connect protection<br></li></ul><div><b>Advanced</b><br></div></div><div><ul><li>Intelligent energy management system for home.<br></li><li></li><li>Power dispatching and demand side response management.</li><li>Distributed virtual power station management.<br></li><li>Frequency droop control, Max.8pcs parallel.<br></li><li>Support storing energy from diesel generator.</li></ul></div>"
            }
        ],
        "specifications": [
            {
                "id": 259,
                "label": "Output Voltage",
                "value": "220V， 230 V，240V"
            },
            {
                "id": 253,
                "label": "MAX.DC Input Power",
                "value": "12kW"
            },
            {
                "id": 257,
                "label": "Battery Voltage Range",
                "value": "40-60V"
            },
            {
                "id": 255,
                "label": "Nominal voltage (Vdc)",
                "value": "48V"
            },
            {
                "id": 260,
                "label": "Output Power Factor",
                "value": "0.8 leading … 0.8 lagging"
            },
            {
                "id": 261,
                "label": "Operating Temperature Range",
                "value": "-25 ~ +60°C"
            },
            {
                "id": 814,
                "label": "Parallel Operation",
                "value": "8"
            },
            {
                "id": 256,
                "label": "MAX.Charging/Discharging Current",
                "value": "190A/190A"
            },
            {
                "id": 254,
                "label": "MAX.Input Current",
                "value": "13A/13A/13A/13A"
            },
            {
                "id": 258,
                "label": "Power Output",
                "value": "8kW"
            },
            {
                "id": 252,
                "label": "MAX.DC Input Voltage",
                "value": "500V"
            }
        ],
        "documents": [
            {
                "id": 7,
                "description": "Growcol-R8KL1-Hybrid-Inverter-Datasheet.pdf",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-R8KL1-Hybrid-Inverter-Datasheet.pdf"
            },
            {
                "id": 8,
                "description": "Growcol-R8KL1-Hybrid-Inverter-User-Manual.pdf",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-R8KL1-Hybrid-Inverter-User-Manual.pdf"
            },
            {
                "id": 9,
                "description": "Growcol-Warranty-Card.pdf",
                "url": "https://www.solarcentral.co.za/pdf/Growcol-Warranty-Card.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 4,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/growcol-8kw-hybrid/",
                "code": "GRO-R8KL1",
                "sku": "R8KL1",
                "inventoryStatus": "LOWSTOCK",
                "cost": 32200,
                "markup": 0,
                "retail": 32200
            }
        ],
        "ratings": [
            {
                "id": 41,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 42,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 56,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 11,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 50,
        "uid": "e4421e54-0943-4338-aeca-721595ec49ac",
        "code": "VIC-QUA481030010",
        "name": "Quattro 48/10000/140-100/100",
        "longName": "Victron Quattro 48/10000/140-100/100 230V VE.Bus (VIC-QUA481030010)",
        "brand": "Victron",
        "image": "https://www.solarcentral.co.za/images/VIC-QUA481030010.png",
        "price": 71843.8,
        "category": "Inverters",
        "subCategory": "Grid-Tied, Residential",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Victron Quattro 48/10000/140-100/100 230V VE.Bus",
        "keywords": "solar storage, hybrid inverter, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, Victron,Quattro,48/10000/140-100/100,230V,VE.Bus",
        "description": "The Victron Quattro 48/10000/140-100/100 230V VE.Bus is a highly advanced and versatile inverter/charger system designed to provide reliable and efficient power conversion in various applications. Combining the functionalities of an inverter and a charger, the Quattro offers seamless integration between different power sources, making it ideal for off-grid, backup power, and renewable energy systems.",
        "root": "victron-quattro-48-10000-140-100",
        "visible": true,
        "highlights": [],
        "overviews": [
            {
                "id": 19,
                "html": "<h4>Product Description</h4><div><br></div><div>The Victron Quattro 48/10000/140-100/100 230V VE.Bus is a highly advanced and versatile inverter/charger system designed to provide reliable and efficient power conversion in various applications. Combining the functionalities of an inverter and a charger, the Quattro offers seamless integration between different power sources, making it ideal for off-grid, backup power, and renewable energy systems.</div><div><br></div><h4>Powerful Inverter:&#160;</h4><div>The Quattro 48/10000/140-100/100 boasts a robust 10,000 VA continuous power output, enabling it to handle demanding loads effortlessly. With a pure sine wave output, it provides clean and stable power, ensuring compatibility with sensitive electronics and appliances.</div><div><br></div><h4>Reliable Battery Charging:&#160;</h4><div>Equipped with a high-performance battery charger, the Quattro can efficiently recharge your batteries from various power sources, such as grid power, generator, or solar panels. Its advanced charging algorithms optimise the charging process, prolonging battery life and maximising the overall system performance.</div><div><br></div><h4>Seamless Transfer:&#160;</h4><div>The Quattro features a built-in automatic transfer switch (ATS) that enables seamless and instantaneous switching between different power sources. In the event of a power outage or when the input power falls outside a set range, the Quattro will automatically transfer the load to the battery power or alternate AC source without any interruption.</div><div><br></div><h4>Parallel and Three-Phase Operation:&#160;</h4><div>For applications requiring higher power output or redundancy, multiple Quattro units can be connected in parallel, enabling scalability and increased power capacity. Additionally, the Quattro can be configured for three-phase operation, providing flexible solutions for commercial and industrial setups.</div><div><br></div><h4>VE.Bus Communication:&#160;</h4><div>The Quattro utilises Victron's VE.Bus communication protocol, allowing seamless integration with other Victron products and system components. This compatibility enhances system monitoring, control, and configuration capabilities, enabling comprehensive management of your power system.</div><div><br></div><h4>Advanced System Monitoring:&#160;</h4><div>The Quattro is compatible with Victron's comprehensive monitoring and control tools, including the Color Control GX and the Victron Remote Management (VRM) portal. These tools provide real-time monitoring of the system performance, allowing you to track power consumption, battery status, and system efficiency conveniently.</div><div><br></div><h4>Robust Construction and Safety Features:&#160;</h4><div>Designed with durability in mind, the Quattro is built to withstand harsh environments. It incorporates advanced protection features such as overload and short circuit protection, temperature monitoring, and a galvanic isolation transformer for enhanced safety and reliability.</div><div><br></div><div>The Victron Quattro 48/10000/140-100/100 230V VE.Bus is an exceptional inverter/charger system that offers high power capacity, efficient operation, and advanced features for a wide range of applications. Whether you need reliable backup power or want to harness the potential of renewable energy, the Quattro ensures optimal performance, flexibility, and peace of mind.</div>"
            }
        ],
        "specifications": [
            {
                "id": 400,
                "label": "Power Output",
                "value": "10kW"
            },
            {
                "id": 401,
                "label": "Inverter Power Output (peak)",
                "value": "20,000 VA"
            },
            {
                "id": 403,
                "label": "Input Voltage Range (AC)",
                "value": "187 - 265 V"
            },
            {
                "id": 405,
                "label": "Maximum Efficiency",
                "value": "94%"
            },
            {
                "id": 406,
                "label": "Parallel Operation",
                "value": "6"
            },
            {
                "id": 409,
                "label": "Weight (kg)",
                "value": "23"
            },
            {
                "id": 402,
                "label": "Input Voltage (AC)",
                "value": "230V"
            },
            {
                "id": 408,
                "label": "Dimensions (H x W x D)",
                "value": "364 x 258 x 218 mm"
            },
            {
                "id": 404,
                "label": "Frequency (Hz)",
                "value": "50/60 Hz (auto-selectable)"
            },
            {
                "id": 407,
                "label": "Operating Temperature Range",
                "value": "-40°C to +50°C"
            }
        ],
        "documents": [
            {
                "id": 57,
                "description": "Victron - Quattro 4815000200-100100 230V VE.Bus - Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/QUA483150000-Victron-Quattro-4815000200-100100-230V-VE.Bus-Datasheet.pdf"
            },
            {
                "id": 60,
                "description": "Victron - Quattro - 3kVA - 15KVA - Inverter x GX Device - ESS Design & installation manual",
                "url": "https://www.solarcentral.co.za/pdf/Victron-Energy-Inverter-Quattro-3kVA-15KVA-Inverter-x-GX-Device-ESS-Design-installation-manual.pdf"
            },
            {
                "id": 59,
                "description": "Victron - Quattro - 3kVA - 15kVA - HUB 4 System Wiring Diagram",
                "url": "https://www.solarcentral.co.za/pdf/Victron-Energy-Inverter-Quattro-3kVA-15kVA-HUB-4-System-Wiring-Diagram.pdf"
            },
            {
                "id": 58,
                "description": "Victron - Quattro - 12,24,48,48 (5000 - 10000) - Manual",
                "url": "https://www.solarcentral.co.za/pdf/Victron-Energy-Inverter-Quattro-12244848-5000-10000-Manual.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 19,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/quattro-48v-quattro-48-10000-140-100-100-230v-ve-bus/",
                "code": "VIC-QUA481030010",
                "sku": "QUA481030010",
                "inventoryStatus": "LOWSTOCK",
                "cost": 71843.8,
                "markup": 0,
                "retail": 71843.8
            }
        ],
        "ratings": [
            {
                "id": 17,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 13,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 19,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 52,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 44,
        "uid": "68bd8757-e0cf-4a05-8fc7-9da96aded191",
        "code": "VIC-QUA483150000",
        "name": "Quattro 48/15000/200",
        "longName": "Victron Quattro 48/15000/200 - 100/100 230V VE Bus (VIC-QUA483150000)",
        "brand": "Victron",
        "image": "https://www.solarcentral.co.za/images/VIC-QUA483150000.png",
        "price": 83898.48,
        "category": "Inverters",
        "subCategory": "Grid-Tied, Residential",
        "inventory": 0,
        "inventoryStatus": "LOWSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Victron Quattro 48/15000/200 - 100/100 230V VE Bus",
        "keywords": "solar storage, hybrid inverter, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, Victron,Quattro,48/15000/200,100/100,230V,VE Bus",
        "description": "Developed for off-grid and backup power applications, the Victron Quattro 48/15000/200-100/100 230V VE.Bus is a high-performance inverter/charger. It is a component of the Victron Energy product line, which focuses on finding ways to store energy for a range of uses.",
        "root": "victron-quattro-48-15000-200",
        "visible": true,
        "highlights": [
            {
                "id": 49,
                "label": "Inverter Type",
                "value": "True Sine Wave Inverter"
            },
            {
                "id": 51,
                "label": "Output Voltage",
                "value": "230V"
            },
            {
                "id": 50,
                "label": "Input Voltage",
                "value": "9.5-17V 19-33V 36-66V"
            },
            {
                "id": 52,
                "label": "Warranty",
                "value": "5 Years"
            }
        ],
        "overviews": [
            {
                "id": 13,
                "html": "<h4>Product Overview</h4><div><br></div><div>The Victron Quattro 48/15000/200 - 100/100 230V VE Bus Inverter is a highly advanced and versatile power conversion device designed for demanding off-grid and backup power applications. With its exceptional power output, advanced features, and reliable performance, it stands as a flagship product in Victron Energy's renowned range of inverters.</div><div><br></div><h4>Powerful Performance:</h4><div>The Quattro 48/15000/200 - 100/100 is capable of delivering an impressive continuous power output of 15,000VA (15kVA) and a peak power rating of 30,000VA (30kVA). This substantial power capability makes it suitable for a wide range of applications, from large residential homes and commercial premises to remote off-grid systems and industrial setups.</div><div><br></div><h4>Dual AC Inputs:</h4><div>One of the notable features of the Quattro inverter is its dual AC inputs. It enables seamless integration with various power sources, such as grid power and generator sets. This capability allows for the automatic transfer of power sources, ensuring uninterrupted power supply and enhanced system reliability.</div><div><br></div><h4>PowerAssist and Solar Integration:</h4><div>The Quattro inverter also incorporates Victron Energy's innovative PowerAssist technology, which provides additional power from alternative sources, such as solar panels, to supplement the available grid or generator power. This feature optimises the use of renewable energy sources, maximising self-consumption and reducing reliance on non-renewable energy.</div><div><br></div><h4>Advanced Battery Management:</h4><div>The VE.Bus system within the Quattro ensures comprehensive battery management and protection. It supports a wide range of battery types and configurations, including lead-acid, lithium-ion, and custom battery banks. The inverter features adaptive charging technology, which adjusts the charging process according to the battery's specific requirements, ensuring optimal performance, extended battery life, and enhanced efficiency.</div><div><br></div><h4>Seamless System Integration:</h4><div>The Quattro inverter seamlessly integrates with Victron's extensive range of system accessories and monitoring solutions. It can be connected to the Color Control GX or Venus GX, allowing users to monitor and control their system from anywhere using the Victron Remote Management (VRM) platform. This remote monitoring capability enables real-time performance tracking, historical data analysis, and system optimisation.</div><div><br></div><h4>Reliable and Durable Design:</h4><div>Built with quality and longevity in mind, the Quattro inverter features a robust construction and high-quality components. It boasts a durable aluminum enclosure that provides effective cooling and protection against harsh environmental conditions. The advanced circuitry ensures low standby power consumption and high efficiency, contributing to energy savings and reduced operating costs.</div><div><br></div><h4>Safety and Compliance:</h4><div>Victron Energy prioritises safety, and the Quattro inverter adheres to the highest international safety and quality standards. It includes multiple built-in protection features, such as short-circuit protection, over-temperature protection, and over-voltage protection. Additionally, the Quattro is compliant with relevant industry regulations, including CE, E-mark, and RoHS.</div><div><br></div><h4>Conclusion:</h4><div>The Victron Quattro 48/15000/200 - 100/100 230V VE Bus Inverter is a versatile and powerful solution for off-grid and backup power systems. With its exceptional power output, advanced features like PowerAssist and dual AC inputs, comprehensive battery management, and seamless system integration, it offers a reliable and efficient energy solution for residential, commercial, and industrial applications. Whether you require reliable backup power or seek to live off-grid sustainably, the Quattro inverter is a dependable choice from a leading manufacturer in the energy industry.</div>"
            }
        ],
        "specifications": [
            {
                "id": 341,
                "label": "Output",
                "value": "230 VAC ± 2% Frequency: 50 Hz ± 0,1%"
            },
            {
                "id": 343,
                "label": "Power Output",
                "value": "15kW"
            },
            {
                "id": 347,
                "label": "General purpose com. port",
                "value": "2x"
            },
            {
                "id": 349,
                "label": "Weight (kg)",
                "value": "72"
            },
            {
                "id": 806,
                "label": "Parallel Operation",
                "value": "6"
            },
            {
                "id": 344,
                "label": "Charge voltage 'absorption' (V DC)",
                "value": "57.6"
            },
            {
                "id": 342,
                "label": "Peak power (W)",
                "value": "25000"
            },
            {
                "id": 345,
                "label": "Charge voltage 'float' (V DC)",
                "value": "55.2"
            },
            {
                "id": 340,
                "label": "Input voltage range (V DC)",
                "value": "9,5 – 17V 19 – 33V 38 – 66V"
            },
            {
                "id": 348,
                "label": "Battery-connection",
                "value": "Four M8 bolts (2 plus and 2 minus connections)"
            },
            {
                "id": 346,
                "label": "Storage mode (V DC)",
                "value": "52.8"
            }
        ],
        "documents": [
            {
                "id": 34,
                "description": "Victron - Quattro - 3kVA - 15kVA - HUB 4 System Wiring Diagram",
                "url": "https://www.solarcentral.co.za/pdf/Victron-Energy-Inverter-Quattro-3kVA-15kVA-HUB-4-System-Wiring-Diagram.pdf"
            },
            {
                "id": 33,
                "description": "Victron - Quattro - 12,24,48,48 (5000 - 10000) - Manual",
                "url": "https://www.solarcentral.co.za/pdf/Victron-Energy-Inverter-Quattro-12244848-5000-10000-Manual.pdf"
            },
            {
                "id": 32,
                "description": "Victron - Quattro 4815000200-100100 230V VE.Bus - Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/QUA483150000-Victron-Quattro-4815000200-100100-230V-VE.Bus-Datasheet.pdf"
            },
            {
                "id": 35,
                "description": "Victron - Quattro - 3kVA - 15KVA - Inverter x GX Device - ESS Design & installation manual",
                "url": "https://www.solarcentral.co.za/pdf/Victron-Energy-Inverter-Quattro-3kVA-15KVA-Inverter-x-GX-Device-ESS-Design-installation-manual.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 13,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/quattro-48-15000-200-100-100-230v-ve-bus/",
                "code": "VIC-QUA483150000",
                "sku": "QUA483150000",
                "inventoryStatus": "LOWSTOCK",
                "cost": 83898.48,
                "markup": 0,
                "retail": 83898.48
            }
        ],
        "ratings": [
            {
                "id": 21,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 39,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 18,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 28,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 80,
        "uid": "c0ebe180-ab8b-4009-8307-e9257dc16d31",
        "code": "SHO-SDC10",
        "name": "5.12KWH LI-ION 48V",
        "longName": "Shoto 5.12kWh Li-Ion Battery (SHO-SDC10)",
        "brand": "Shoto",
        "image": "https://www.solarcentral.co.za/images/SHO-SDC10.png",
        "price": 0,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | SHOTO 5.12KWH LI-ION BATTERY",
        "keywords": "growcol, solar storage, hybrid inverter, MPS0030, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, SHOTO,5.12KWH,LI-ION,BATTERY",
        "description": "The SHOTO 5.12kWh Li-ion Battery is a high-performance energy storage solution that combines advanced technology, long cycle life, and intelligent energy management. It offers users the ability to store and utilise energy efficiently, reducing reliance on the grid and promoting sustainable energy consumption. Whether for residential or commercial applications, the SHOTO battery provides a reliable and scalable solution for optimising energy usage and maximising the benefits of renewable energy sources.",
        "root": "shoto-5.12kwh-li-ion-48v",
        "visible": true,
        "highlights": [
            {
                "id": 184,
                "label": "Usable Capacity",
                "value": "4.6kWh"
            },
            {
                "id": 186,
                "label": "Warranty",
                "value": "3 Years"
            },
            {
                "id": 185,
                "label": "Weight",
                "value": "43kg"
            },
            {
                "id": 183,
                "label": "Nominal Capacity",
                "value": "5.12kWh"
            }
        ],
        "overviews": [
            {
                "id": 48,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The SHOTO 5.12kWh Li-ion Battery is an advanced energy storage solution designed to meet the growing demands of residential and commercial applications. It offers a reliable and efficient way to store excess energy generated from renewable sources or during off-peak hours, allowing users to optimize their energy consumption and reduce reliance on the grid.</div><div><br></div><h4>High Energy Density:&#160;</h4><div>The SHOTO 5.12kWh Li-ion Battery incorporates advanced lithium-ion technology, providing a high energy density that maximizes the storage capacity in a compact and space-saving design. This enables efficient energy storage without compromising on performance.</div><div><br></div><h4>Long Cycle Life:&#160;</h4><div>With a long cycle life, the SHOTO battery is built to last. It can withstand numerous charge and discharge cycles, allowing for reliable operation and ensuring a prolonged lifespan. This makes it a cost-effective investment for users seeking a durable and dependable energy storage solution.</div><div><br></div><h4>Rapid Charging and Discharging:&#160;</h4><div>The battery is engineered to support rapid charging and discharging capabilities, allowing for quick energy transfers when needed. This feature is particularly useful in applications where there are fluctuations in energy supply or high-power demand situations.</div><div><br></div><h4>Scalable and Modular Design:&#160;</h4><div>The SHOTO 5.12kWh Li-ion Battery features a scalable and modular design, enabling users to expand their storage capacity by connecting multiple units together. This flexibility allows for customization based on specific energy needs, making it suitable for a wide range of applications, from residential households to commercial installations.</div><div><br></div><h4>Intelligent Energy Management:&#160;</h4><div>The battery system incorporates intelligent energy management technology, which optimizes energy usage based on user-defined preferences and real-time data. It enables efficient load shifting, time-of-use optimization, and backup power capabilities, providing greater control over energy consumption and reducing electricity costs.</div><div><br></div><h4>Advanced Safety Features:&#160;</h4><div>The SHOTO battery prioritizes safety with its built-in protection mechanisms. It includes features such as overcharge protection, over-discharge protection, short-circuit protection, and thermal protection, ensuring safe and reliable operation under various conditions.</div><div><br></div><h4>Compatibility and Integration:&#160;</h4><div>The SHOTO battery is designed for seamless integration with solar PV systems, wind turbines, and other renewable energy sources. It can be easily connected to existing grid-tied or off-grid systems, allowing for efficient energy management and maximizing the utilization of renewable energy resources.</div></div>"
            }
        ],
        "specifications": [
            {
                "id": 718,
                "label": "Chemistry",
                "value": "Lithium-Ion"
            },
            {
                "id": 716,
                "label": "Voltage",
                "value": "51.2V"
            },
            {
                "id": 725,
                "label": "Weight",
                "value": "43kg"
            },
            {
                "id": 719,
                "label": "Depth of Discharge",
                "value": "90%"
            },
            {
                "id": 724,
                "label": "Operating Temperature",
                "value": "20°C to 60°C (-4°F to 140°F)"
            },
            {
                "id": 722,
                "label": "Cycle Life",
                "value": "≥5000 @25 Cº"
            },
            {
                "id": 723,
                "label": "Max Parallel Quantity",
                "value": "16"
            },
            {
                "id": 717,
                "label": "Capacity",
                "value": "5.12kWh"
            },
            {
                "id": 726,
                "label": "Dimensions (W*H*D)",
                "value": "442*133*420mm"
            }
        ],
        "documents": [
            {
                "id": 112,
                "description": "Warranty Letter for Shoto Li-ion Battery",
                "url": "https://www.solarcentral.co.za/pdf/Warranty-Letter-for-Shoto-Li-ion-battey-5-years1.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 46,
                "distributor": "SolarWay",
                "distributorClient": "za.co.visualage.inventory.distributor.SolarWayDistributorClient",
                "refreshUrl": "https://www.solarwaysuppliers.co.za/product/shoto-5-12kwh-li-ion-battery-2/",
                "code": "SHO-SDC10",
                "sku": "SH-SDC10",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.038,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 61,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 71,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 77,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 63,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 70,
        "uid": "ecc06562-cd42-4bd6-ac6f-b3c9e31f7c41",
        "code": "PYL-H48074HV48V",
        "name": "H48074 HV 3.5KWH 48V",
        "longName": "Pylontech H48074 HV 3.5KWH 48V Battery (PYL-H48074HV48V)",
        "brand": "Pylontech",
        "image": "https://www.solarcentral.co.za/images/PYL-H48074HV48V.png",
        "price": 264.5,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "SOLDOUT",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Pylontech H48074 HV 3.5KWH 48V Battery",
        "keywords": "solar storage, hybrid inverter, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, Pylontech,H48074,HV,3.5KWH,48V,Battery",
        "description": "The Pylontech H48074 HV 3.5KWH 48V Battery, a cutting-edge energy storage solution designed to power your home or business with efficiency and reliability. With its advanced technology and impressive specifications, this battery is set to revolutionise the way you store and utilise energy.",
        "root": "pylon-h48074-hv-3.5kwh-48v",
        "visible": true,
        "highlights": [
            {
                "id": 149,
                "label": "Max Charging",
                "value": "74Ah"
            },
            {
                "id": 147,
                "label": "Battery Type",
                "value": "Lithium Iron Phosphate"
            },
            {
                "id": 148,
                "label": "Nominal Voltage",
                "value": "48V"
            },
            {
                "id": 150,
                "label": "Warranty",
                "value": "10 Years"
            }
        ],
        "overviews": [
            {
                "id": 39,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The Pylontech H48074 HV 3.5KWH 48V Battery, a cutting-edge energy storage solution designed to power your home or business with efficiency and reliability. With its advanced technology and impressive specifications, this battery is set to revolutionise the way you store and utilise energy.</div><div><br></div><div>Featuring a high voltage design and a capacity of 3.5KWH, this battery provides ample energy storage to meet your power demands. Whether you're looking to power essential appliances during outages or maximise your solar energy utilisation, the Pylontech H48074 HV battery has got you covered.</div><div><br></div><div>One of the standout features of this battery is its versatility. It can seamlessly integrate with various renewable energy systems, such as solar panels, wind turbines, or hydroelectric generators. By harnessing clean and sustainable energy sources, you can reduce your carbon footprint while enjoying uninterrupted power supply.</div><div><br></div><div>Equipped with advanced lithium-ion technology, the Pylontech H48074 HV battery offers exceptional performance and longevity. Its high cycle life ensures that you can rely on this battery for years to come, delivering consistent power whenever you need it.</div><div><br></div><div>Furthermore, the H48074 HV battery is designed with safety in mind. It incorporates multiple layers of protection, including overcharge, over-discharge, and over-temperature safeguards. This ensures that your investment remains safe and reliable, without compromising on performance.</div><div><br></div><div>Upgrade your energy storage capabilities with the Pylontech H48074 HV 3.5KWH 48V Battery and experience the future of sustainable power. Whether you're a homeowner or a business owner, this battery will provide you with a seamless, efficient, and eco-friendly energy storage solution.</div></div>"
            }
        ],
        "specifications": [
            {
                "id": 615,
                "label": "Battery Chemistry",
                "value": "Lithium-ion"
            },
            {
                "id": 617,
                "label": "Dimensions (W x D x H)",
                "value": "442mm x 410mm x 89mm"
            },
            {
                "id": 616,
                "label": "Communication",
                "value": "CAN, RS485"
            },
            {
                "id": 610,
                "label": "Capacity",
                "value": "3.5kWh"
            },
            {
                "id": 614,
                "label": "Operating Temperature Range",
                "value": "-10°C to 50°C"
            },
            {
                "id": 618,
                "label": "Weight",
                "value": "16.5kg"
            },
            {
                "id": 613,
                "label": "Cycle Life",
                "value": "6000 cycles (@ 80% DoD)"
            },
            {
                "id": 609,
                "label": "Battery Model",
                "value": "H48074 HV"
            },
            {
                "id": 611,
                "label": "Nominal Voltage",
                "value": "48V"
            },
            {
                "id": 820,
                "label": "Scalability",
                "value": "3"
            },
            {
                "id": 612,
                "label": "Minimum/Maximum Voltage",
                "value": "40 - 54V"
            }
        ],
        "documents": [
            {
                "id": 95,
                "description": "Pylontech H48050 SC0500 100S Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-H48050-SC0500-100S-Powercube-Datasheet.pdf"
            },
            {
                "id": 96,
                "description": "Pylontech H48050 SC0500 100S Safety Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-PF25-US2000-Phantom-S-EXTRA2000-FB500-H48050-Safety-Datasheet.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 37,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/h48074-high-voltage-system-battery-module/",
                "code": "PYL-H48074HV48V",
                "sku": "PYLON4H48074HV",
                "inventoryStatus": "SOLDOUT",
                "cost": 264.5,
                "markup": 0,
                "retail": 264.5
            }
        ],
        "ratings": [
            {
                "id": 73,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 75,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 79,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 74,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 66,
        "uid": "d5cbbf46-4541-48de-8c0f-346964b02677",
        "code": "PYL-UP5000",
        "name": "UP5000 4.8Kwh LI-ION 48V",
        "longName": "Pylontech UP5000 4.8Kwh LI-ION 48V Battery (PYL-UP5000)",
        "brand": "Pylontech",
        "image": "https://www.solarcentral.co.za/images/PYL-UP5000.png",
        "price": 17192.5,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Pylontech UP5000 4.8Kwh LI-ION 48V Battery",
        "keywords": "solar storage, hybrid inverter, solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, Pylontech,UP5000,4.8Kwh,LI-ION,48V,Battery",
        "description": "The Pylontech UP5000 4.8KWh LI-ION 48V Battery is an advanced energy storage solution designed to provide reliable and efficient power storage for various applications. Manufactured by Pylontech, a renowned provider of innovative battery technologies, this battery offers high-performance capabilities for both residential and commercial use.",
        "root": "pylon-up5000-4.8kwh-48v",
        "visible": true,
        "highlights": [
            {
                "id": 133,
                "label": "Nominal Capacity",
                "value": "4800Wh"
            },
            {
                "id": 134,
                "label": "Warranty",
                "value": "5 Years"
            },
            {
                "id": 131,
                "label": "Battery Type",
                "value": "Lithium Battery"
            },
            {
                "id": 132,
                "label": "Nominal Voltage",
                "value": "48V"
            }
        ],
        "overviews": [
            {
                "id": 35,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The Pylontech UP5000 4.8KWh LI-ION 48V Battery is an advanced energy storage solution designed to provide reliable and efficient power storage for various applications. Manufactured by Pylontech, a renowned provider of innovative battery technologies, this battery offers high-performance capabilities for both residential and commercial use.</div><div><br></div><h4>Battery Chemistry:&#160;</h4><div>The UP5000 battery utilises lithium-ion (Li-ion) chemistry, which is known for its high energy density, long cycle life, and efficient energy storage capabilities. Li-ion technology provides reliable performance and ensures optimal power utilisation.</div><div><br></div><h4>Capacity:&#160;</h4><div>The UP5000 battery has a total capacity of 4.8 kilowatt-hours (KWh), allowing for significant energy storage. This capacity makes it suitable for applications such as residential solar systems, off-grid power solutions, and commercial energy management.</div><div><br></div><h4>Voltage:&#160;</h4><div>The battery operates at a nominal voltage of 48 volts (V), which is a standard voltage level for many power systems. This voltage is compatible with various inverters, solar charge controllers, and other components commonly used in energy storage setups.</div><div><br></div><h4>High Discharge and Charge Rates:&#160;</h4><div>The UP5000 battery is capable of high discharge and charge rates, making it suitable for applications with fluctuating power demands. It can efficiently handle peak loads and rapidly charge from renewable energy sources, ensuring reliable power availability.</div><div><br></div><h4>Battery Management System (BMS):&#160;</h4><div>The battery incorporates a built-in Battery Management System that ensures safe and efficient operation. The BMS monitors critical parameters such as voltage, current, and temperature, protecting the battery from overcharging, over-discharging, and other potentially damaging conditions.</div><div><br></div><h4>Long Cycle Life:&#160;</h4><div>The UP5000 battery offers a long cycle life, capable of enduring thousands of charge and discharge cycles without significant capacity loss. This longevity ensures a cost-effective and durable energy storage solution, minimising the need for frequent replacements.</div><div><br></div><h4>Communication and Monitoring:&#160;</h4><div>The battery supports communication protocols such as CAN bus or RS485, allowing for integration with energy management systems. It provides real-time monitoring of battery status, performance data, and diagnostic information for effective system management.</div><div><br></div><div><br></div></div>"
            }
        ],
        "specifications": [
            {
                "id": 552,
                "label": "Discharge Voltage",
                "value": "44.5Vdc"
            },
            {
                "id": 556,
                "label": "Certification",
                "value": "IEC62619/CE/ UN38.3"
            },
            {
                "id": 821,
                "label": "Scalability",
                "value": "16"
            },
            {
                "id": 549,
                "label": "Nominal Voltage",
                "value": "48V"
            },
            {
                "id": 553,
                "label": "Charge Voltage",
                "value": "52.5 ~ 53.5Vdc"
            },
            {
                "id": 551,
                "label": "Capacity",
                "value": "4.56kWh"
            },
            {
                "id": 550,
                "label": "Nominal Capacity",
                "value": "4,800Wh"
            },
            {
                "id": 555,
                "label": "Shelf Temperature",
                "value": "-20~60℃"
            },
            {
                "id": 554,
                "label": "Working Temperature",
                "value": "0~50℃ Charge / -10~50℃ Discharge"
            }
        ],
        "documents": [
            {
                "id": 84,
                "description": "Pylontech ESS Battery System UP5000 Compatibility List",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-ESS-Battery-System-UP5000-series-Compatibility-List.pdf"
            },
            {
                "id": 83,
                "description": "Pylontech ESS Battery System UP5000 Warranty",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-ESS-Battery-System-UP5000-series-Warranty.pdf"
            },
            {
                "id": 82,
                "description": "Pylontech ESS Battery System UP5000 User Manual",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-ESS-Battery-System-UP5000-series-User-Manual.pdf"
            },
            {
                "id": 81,
                "description": "Pylontech ESS Battery System UP5000 Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-ESS-Battery-System-UP5000-series-Datasheet.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 32,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/pylon-up5000-4-8kw-48v/",
                "code": "PYL-UP5000",
                "sku": "PYLON-UP5000",
                "inventoryStatus": "INSTOCK",
                "cost": 17192.5,
                "markup": 0,
                "retail": 17192.5
            }
        ],
        "ratings": [
            {
                "id": 78,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 70,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 80,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 62,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 68,
        "uid": "1ac0f957-0389-4f07-8fbb-5ff523e7c2a5",
        "code": "PYL-US3000C",
        "name": "US3000C 3.5Kwh LI-ION 48V",
        "longName": "Pylontech US3000C 3.5Kwh (LiFePO4) 48V Battery (PYL-US3000C)",
        "brand": "Pylontech",
        "image": "https://www.solarcentral.co.za/images/PYL-US3000C.png",
        "price": 19412,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | Pylontech US3000C 3.5Kwh (LiFePO4) 48V Battery",
        "keywords": "solar storage, hybrid inverter,solar, accredited installers, south africa, solar quotes, pv-panels, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, Pylontech,US3000C,3.5Kwh,LiFePO4,48V,Battery",
        "description": "The Pylontech US3000C 3.5KWh (LiFePO4) 48V battery is a high-performance lithium iron phosphate (LiFePO4) battery designed for residential and commercial energy storage systems. With a capacity of 3.5 kilowatt-hours (KWh) and a voltage rating of 48 volts (V), it offers reliable and efficient energy storage solutions.\n\nThe US3000C battery utilises LiFePO4 chemistry, known for its excellent safety, long cycle life, and thermal stability. This chemistry ensures that the battery is resistant to overheating, thermal runaway, and other safety concerns, making it a reliable choice for energy storage applications.",
        "root": "pylon-us3000c-3.5kwh-48v",
        "visible": true,
        "highlights": [
            {
                "id": 139,
                "label": "Battery Type",
                "value": "Lithium Battery"
            },
            {
                "id": 140,
                "label": "Nominal Voltage",
                "value": "48V"
            },
            {
                "id": 141,
                "label": "Max Charging",
                "value": "74A"
            },
            {
                "id": 142,
                "label": "Warranty",
                "value": "10 Years"
            }
        ],
        "overviews": [
            {
                "id": 37,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The Pylontech US3000C 3.5KWh (LiFePO4) 48V battery is a high-performance lithium iron phosphate (LiFePO4) battery designed for residential and commercial energy storage systems. With a capacity of 3.5 kilowatt-hours (KWh) and a voltage rating of 48 volts (V), it offers reliable and efficient energy storage solutions.</div><div><br></div><div>The US3000C battery utilises LiFePO4 chemistry, known for its excellent safety, long cycle life, and thermal stability. This chemistry ensures that the battery is resistant to overheating, thermal runaway, and other safety concerns, making it a reliable choice for energy storage applications.</div><div><br></div><div>The battery is designed to be modular and scalable, allowing for easy expansion of the energy storage capacity. Multiple US3000C batteries can be connected in parallel to meet the specific energy requirements of different installations. This flexibility makes it suitable for both small residential setups and larger commercial installations.</div><div><br></div><div>The US3000C battery incorporates an advanced Battery Management System (BMS) that ensures optimal performance, balancing the cells, and protecting against overcharging, over-discharging, and short circuits. The BMS also allows for easy monitoring and control of the battery's status, including voltage, current, and temperature, through a user-friendly interface.</div><div><br></div><div>Overall, the Pylontech US3000C 3.5KWh (LiFePO4) 48V battery offers a reliable and efficient energy storage solution with its high capacity, voltage rating, and safety features. It is well-suited for both residential and commercial applications, providing a stable and sustainable power supply for a variety of energy storage needs.</div></div>"
            }
        ],
        "specifications": [
            {
                "id": 580,
                "label": "Maximum Charge Voltage",
                "value": "54V"
            },
            {
                "id": 577,
                "label": "Capacity",
                "value": "3.5kWh"
            },
            {
                "id": 585,
                "label": "Dimensions (W x H x D)",
                "value": "440mm x 89mm x 420mm"
            },
            {
                "id": 581,
                "label": "Maximum Continuous Discharge Current",
                "value": "100Ah"
            },
            {
                "id": 583,
                "label": "Cycle Life",
                "value": "6,000 cycles (@ 80% DOD)"
            },
            {
                "id": 578,
                "label": "Nominal Voltage",
                "value": "48V"
            },
            {
                "id": 822,
                "label": "Scalability",
                "value": "16"
            },
            {
                "id": 579,
                "label": "Chemistry",
                "value": "Lithium iron phosphate (LiFePO4)"
            },
            {
                "id": 582,
                "label": "Efficiency",
                "value": "96% - 98%"
            },
            {
                "id": 584,
                "label": "Operating Temperature Range",
                "value": "-10°C to 50°C"
            },
            {
                "id": 586,
                "label": "Weight",
                "value": "23.5 kg (51.8 lbs)"
            }
        ],
        "documents": [
            {
                "id": 90,
                "description": "Pylontech US2000C-US3000C CE",
                "url": "https://www.solarcentral.co.za/pdf/US2000C-US3000C-CE.pdf"
            },
            {
                "id": 92,
                "description": "Pylontech US2000C-US3000C Safety Data Sheet",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-Lithium-Battery-US2000C-Safety-Data-Sheet.pdf"
            },
            {
                "id": 91,
                "description": "Pylontech US2000C-US3000C CQC Test and Criteria",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-Lithium-Battery-US2000C-CQC-Test-and-Criteria.pdf"
            },
            {
                "id": 89,
                "description": "Pylontech US2000C-US3000C Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Pylontech-Energy-Storage-System-US2000C-US3000C-Datasheet.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 34,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/us3000c-3-5kw/",
                "code": "PYL-US3000C",
                "sku": "PYLONUS3000C",
                "inventoryStatus": "INSTOCK",
                "cost": 18487.62,
                "markup": 0.05,
                "retail": 19412
            },
            {
                "id": 35,
                "distributor": "SolarWay",
                "distributorClient": "za.co.visualage.inventory.distributor.SolarWayDistributorClient",
                "refreshUrl": "https://www.solarwaysuppliers.co.za/product/pylontech-us3000-c-3-5kwh-li-ion-solar-battery-excl-brackets/",
                "code": "PYL-US3000C",
                "sku": "US3000C",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.027,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 57,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 69,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 60,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 72,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 85,
        "uid": "2079f8fc-7281-4c6b-9726-98397b55b367",
        "code": "SUN-BATT-10.65",
        "name": "Wall Mount 10.65kWh Lithium",
        "longName": "SUNSYNK Wall Mount 10.65kWh Lithium Battery (SUN-BATT-10.65)",
        "brand": "Sunsynk",
        "image": "https://www.solarcentral.co.za/images/SUN-BATT-10.65.png",
        "price": 40693,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | SUNSYNK Wall Mount 10.65kWh Lithium Battery",
        "keywords": " solar storage, solar, accredited installers, south africa, solar quotes, solar batteries, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, SUNSYNK,Wall,Mount,10.65kWh,Lithium,Battery",
        "description": "The Sunsynk Wall Mount 10.65kWh Lithium Battery is a lithium battery with an operating voltage range between 45.6~56.16V. It is designed for residential energy storage applications and works together with a 48v battery hybrid inverter. The Sunsynk Wall Mount 10.65kWh Lithium Battery is not suitable for supporting life-sustaining medical devices. ",
        "root": "sunsynk-10.65kwh-lithium",
        "visible": true,
        "highlights": [
            {
                "id": 201,
                "label": "Nominal Capacity",
                "value": "208Ah"
            },
            {
                "id": 199,
                "label": "Battery Type",
                "value": "Lithium Battery"
            },
            {
                "id": 200,
                "label": "Nominal Voltage",
                "value": "12.8V"
            },
            {
                "id": 202,
                "label": "Warranty",
                "value": "10 Years"
            }
        ],
        "overviews": [
            {
                "id": 52,
                "html": "<h4>Product Description</h4><div><br></div><div>The&#160;Sunsynk Wall Mount 10.65kWh Lithium Battery is a lithium battery with an operating voltage range between 45.6 ~ 56.16V. It is designed for&#10;residential energy storage applications and works together with a 48v battery hybrid inverter. The Sunsynk&#160;Wall Mount 10.65kWh Lithium Battery is not suitable for supporting life-sustaining medical devices.&#160;</div><div><br></div><div>The Sunsynk&#160;Wall Mount 10.65kWh Lithium Battery has built-in BMS (Battery Management System), which can manage and monitor cells information including voltage, current and temperature. Besides that, BMS can balance cells charging to extend cycle&#10;life. BMS has protection functions including over-dis- charge, over-charge, over-current and high/low temperature; the system can automatically manage charge state, discharge state and balance state.&#160;</div><div><br></div><div>Multiple Sunsynk&#160;Wall Mount 10.65kWh Lithium Batteries can be connected in parallel to expand capacity and power, 8 Sunsynk&#160;Wall Mount 10.65kWh Lithium Batteries can be&#10;connected in parallel at most.<br></div>"
            }
        ],
        "specifications": [
            {
                "id": 755,
                "label": "Max Charge / Discharge Current",
                "value": "100A"
            },
            {
                "id": 763,
                "label": "Charge Voltage",
                "value": "55.68 ~ 56.16Vdc"
            },
            {
                "id": 759,
                "label": "Working Temperature",
                "value": "-20ºC ~ 60ºC"
            },
            {
                "id": 758,
                "label": "Weight",
                "value": "91.9kg"
            },
            {
                "id": 757,
                "label": "Dimension (W×D×H mm)",
                "value": "55 × 16 × 83.6 cm"
            },
            {
                "id": 818,
                "label": "Scalability",
                "value": "8"
            },
            {
                "id": 761,
                "label": "Capacity",
                "value": "10.65kWh"
            },
            {
                "id": 762,
                "label": "Battery Energy",
                "value": "10,640 Wh"
            },
            {
                "id": 764,
                "label": "Discharge Voltage",
                "value": "45.6 - 56.16Vdc"
            },
            {
                "id": 756,
                "label": "Short Circuit Current",
                "value": "350A"
            },
            {
                "id": 760,
                "label": "Nominal Voltage",
                "value": "51.2Vdc"
            }
        ],
        "documents": [
            {
                "id": 115,
                "description": "Sunsynk 10 Year Battery Inverter Warranty",
                "url": "https://www.solarcentral.co.za/pdf/10-Year-Battery-Inverter-Warranty.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 98,
                "distributor": "Herholdts",
                "distributorClient": "za.co.visualage.inventory.distributor.HerholdtsDistributorClient",
                "refreshUrl": "https://herholdts.co.za/pi70643/sunsynk-battery-lfp-wall-mount-10.65kwh-51.2v/",
                "code": "SUN-BATT-10.65",
                "sku": "SUN-BATT-10.65",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.07,
                "retail": 0
            },
            {
                "id": 99,
                "distributor": "Sustainable",
                "distributorClient": "za.co.visualage.inventory.distributor.SustainableDistributorClient",
                "refreshUrl": "https://www.sustainable.co.za/collections/lithium-batteries/products/sunsynk-wall-mount-10-65kwh-51-2v-lithium-battery?_pos=3&_fid=24d17dd09&_ss=c",
                "code": "SUN-BATT-10.65",
                "sku": "SUN-BATT-10.65",
                "inventoryStatus": "INSTOCK",
                "cost": 38030.84,
                "markup": 0.07,
                "retail": 40693
            }
        ],
        "ratings": [
            {
                "id": 65,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 76,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 58,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 67,
                "type": "Warranty",
                "rating": 4
            }
        ]
    },
    {
        "id": 84,
        "uid": "c3a2b0b3-93fa-4f00-872a-afc1f6d8cb2e",
        "code": "SUN-BATT-5.32",
        "name": "Wall Mount 5.32kWh Lithium",
        "longName": "SUNSYNK Wall Mount 5.32kWh Lithium Battery (SUN-BATT-5.32)",
        "brand": "Sunsynk",
        "image": "https://www.solarcentral.co.za/images/SUN-BATT-5.32.png",
        "price": 21609,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4,
        "reviews": 0,
        "title": "Solar Central | Products | SUNSYNK Wall Mount 5.32kWh Lithium Battery",
        "keywords": " solar storage, solar, accredited installers, south africa, solar quotes, solar batteries, inverter, inverters, competitive prices, local installers, solar system prices, cost of solar, solar installation companies, best solar companies, solar wholesale distributors, gauteng, limpopo, north west, mpumalanga, free state, northern cape, western cape, eastern cape, kwazulu-natal, SUNSYNK,Wall,Mount,5.32kWh,Lithium,Battery",
        "description": "The Sunsynk Wall Mount 5.32kWh Lithium Battery is a lithium battery with an operating voltage range between 45.6~56.16V. It is designed for residential energy storage applications and works together with a 48v battery hybrid inverter. The Sunsynk Wall Mount 5.32kWh Lithium Battery is not suitable for supporting life-sustaining medical devices. ",
        "root": "sunsynk-5.32kwh-lithium",
        "visible": true,
        "highlights": [
            {
                "id": 195,
                "label": "Battery Type",
                "value": "Lithium Battery"
            },
            {
                "id": 197,
                "label": "Nominal Capacity",
                "value": "104Ah"
            },
            {
                "id": 196,
                "label": "Nominal Voltage",
                "value": "12.8V"
            },
            {
                "id": 198,
                "label": "Warranty",
                "value": "10 Years"
            }
        ],
        "overviews": [
            {
                "id": 51,
                "html": "<h4>Product Description</h4><div><br></div><div>The&#160;Sunsynk Wall Mount 5.32kWh Lithium Battery is a lithium battery with an operating voltage range between 45.6~56.16V. It is designed for&#10;residential energy storage applications and works together with a 48v battery hybrid inverter. The Sunsynk&#160;Wall Mount 5.32kWh Lithium Battery is not suitable for supporting life-sustaining medical devices.&#160;</div><div><br></div><div>The Sunsynk&#160;Wall Mount 5.32kWh Lithium Battery has built-in BMS (Battery Management System), which can manage and monitor cells information including voltage, current and temperature. Besides that, BMS can balance cells charging to extend cycle&#10;life. BMS has protection functions including over-dis- charge, over-charge, over-current and high/low temperature; the system can automatically manage charge state, discharge state and balance state.&#160;</div><div><br></div><div>Multiple Sunsynk&#160;Wall Mount 5.32kWh Lithium Batteries can be connected in parallel to expand capacity and power, 8 Sunsynk&#160;Wall Mount 5.32kWh Lithium Batteries can be&#10;connected in parallel at most.<br></div>"
            }
        ],
        "specifications": [
            {
                "id": 754,
                "label": "Working Temperature",
                "value": "-20ºC ~ 60ºC"
            },
            {
                "id": 745,
                "label": "Nominal Voltage",
                "value": "51.2Vdc"
            },
            {
                "id": 748,
                "label": "Charge Voltage",
                "value": "55.68 ~ 56.16Vdc"
            },
            {
                "id": 749,
                "label": "Discharge Voltage",
                "value": "45.6 - 56.16Vdc"
            },
            {
                "id": 750,
                "label": "Max Charge / Discharge Current",
                "value": "100A"
            },
            {
                "id": 819,
                "label": "Scalability",
                "value": "8"
            },
            {
                "id": 747,
                "label": "Battery Energy",
                "value": "5320 Wh"
            },
            {
                "id": 752,
                "label": "Dimension (W×D×H mm)",
                "value": "450x520x185mm"
            },
            {
                "id": 746,
                "label": "Capacity",
                "value": "5.32kWh"
            },
            {
                "id": 751,
                "label": "Short Circuit Current",
                "value": "350A"
            },
            {
                "id": 753,
                "label": "Weight",
                "value": "46.5kg"
            }
        ],
        "documents": [
            {
                "id": 114,
                "description": "Sunsynk Lithium 5.32kWh Wall Mounted User Manual v3 English",
                "url": "https://www.solarcentral.co.za/pdf/Sunsynk_SUNBAT_5.32_WallMounted_UserManual_v3_English.pdf"
            }
        ],
        "images": [],
        "distributors": [
            {
                "id": 101,
                "distributor": "Sustainable",
                "distributorClient": "za.co.visualage.inventory.distributor.SustainableDistributorClient",
                "refreshUrl": "https://www.sustainable.co.za/collections/lithium-batteries/products/sunsynk-wall-mount-5-32kwh-51-2v-lithium-battery",
                "code": "SUN-BATT-5.32",
                "sku": "SUN-BATT-5.32",
                "inventoryStatus": "INSTOCK",
                "cost": 20195.33,
                "markup": 0.07,
                "retail": 21609
            },
            {
                "id": 97,
                "distributor": "Herholdts",
                "distributorClient": "za.co.visualage.inventory.distributor.HerholdtsDistributorClient",
                "refreshUrl": "https://herholdts.co.za/pi70644/sunsynk-battery-lfp-wall-mount-5.32kwh-51.2v/",
                "code": "SUN-BATT-5.32",
                "sku": "SUN-BATT-5.32",
                "inventoryStatus": "SOLDOUT",
                "cost": 0,
                "markup": 0.07,
                "retail": 0
            }
        ],
        "ratings": [
            {
                "id": 66,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 59,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 64,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 68,
                "type": "Features",
                "rating": 4
            }
        ]
    },
    {
        "id": 81,
        "uid": "308bfdbf-301e-408f-bac4-8d82d2f087af",
        "code": "LR5-72HPH-550M",
        "name": "Longi Solar 550W Mono",
        "longName": "Longi Solar 550W Mono",
        "brand": "Longi",
        "image": "https://www.solarcentral.co.za/images/LR5-72HPH-550M.png",
        "price": 1992,
        "category": "PV Panels",
        "subCategory": "Monocrystalline",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4.6,
        "reviews": 1,
        "title": "Solar Central | Products | Longi Solar 550W Mono",
        "keywords": "Longi Solar 550W, high-efficiency solar panel, monocrystalline solar module, PERC technology, 550W solar panel, solar energy solution, load-shedding solution, solar panel efficiency, Longi Solar warranty, sustainable energy, solar panel installation, high-performance PV panel, residential solar panel, commercial solar panel, utility-scale solar panel, solar panel durability, low LID solar panel, gallium-doped solar technology, solar panel price, South Africa",
        "description": "Longi Solar 550W Monocrystalline PV Panel",
        "root": "longi-solar-550w-mono",
        "visible": true,
        "highlights": [
            {
                "id": 324,
                "label": "Panel Efficiency (%)",
                "value": "21.5"
            },
            {
                "id": 326,
                "label": "Warranty",
                "value": "12 Years"
            },
            {
                "id": 325,
                "label": "Weight (kg)",
                "value": "27.2"
            },
            {
                "id": 323,
                "label": "Maximum Power (Pmax/W)",
                "value": "550"
            }
        ],
        "overviews": [
            {
                "id": 101,
                "html": "<h4>Product Description</h4><p><strong>The Longi Solar 550W Mono PV Panel</strong>is a high-efficiency monocrystalline solar module designed to deliver exceptional performance for residential, commercial, and utility-scale solar projects in South Africa. Powered by advanced PERC (Passivated Emitter Rear Cell) technology and featuring 144 half-cut cells (6x24), this panel achieves a remarkable module efficiency of up to 21.5%, maximising energy output even in limited spaces.</p><p>With a<strong>rated power output of 550W</strong>, the panel ensures significant electricity generation under South Africa’s abundant sunshine, helping reduce energy bills and carbon footprints. Its open-circuit voltage (Voc) of 49.9V and<strong>maximum power voltage (Vmp) of 41.96V</strong>make it compatible with a wide range of inverters and solar systems. The panel’s smart soldering and gallium-doped technology minimise power degradation and enhance long-term reliability, ensuring consistent performance over its lifespan.</p><p>Built to withstand South Africa’s diverse climates, the Longi 550W panel features a robust<strong>anodised aluminium frame</strong>and<strong>3.2mm tempered glass</strong>, offering resistance to harsh weather conditions like hail, wind, and UV exposure. Weighing 27.2kg and measuring 2278x1134x35mm, it’s designed for easy installation on rooftops or ground-mounted systems. The IP68 junction box and MC4 connectors ensure secure and efficient connections.</p><p>The panel comes with a<strong>12-year product warranty</strong>and a<strong>25-year linear power output warranty</strong>, guaranteeing peace of mind for South African installers and homeowners. Its sleek design integrates seamlessly into various architectural styles, making it ideal for both aesthetic and functional applications. Additionally, the panel’s low LID (Light-Induced Degradation) and optimised electrical parameters ensure higher energy yield and reduced hot-spot risks.</p><p>Perfect for combating load-shedding and rising electricity costs in South Africa, the Longi Solar 550W Mono PV Panel is a reliable, high-performance solution for sustainable energy needs.</p>"
            }
        ],
        "specifications": [
            {
                "id": 836,
                "label": "Power Output",
                "value": "550W"
            },
            {
                "id": 837,
                "label": "Module Efficiency",
                "value": "21.5%"
            },
            {
                "id": 841,
                "label": "Maximum Power Current (Imp)",
                "value": "13.11 A"
            },
            {
                "id": 834,
                "label": "Device",
                "value": "Solar Panel"
            },
            {
                "id": 840,
                "label": "Short Circuit Current (Isc)",
                "value": "14.00A"
            },
            {
                "id": 842,
                "label": "Weight",
                "value": "27.2kg"
            },
            {
                "id": 843,
                "label": "Product Warranty",
                "value": "12 years"
            },
            {
                "id": 835,
                "label": "Type",
                "value": "Monocrystalline"
            },
            {
                "id": 838,
                "label": "Open Circuit Voltage (Voc)",
                "value": "49.9V"
            },
            {
                "id": 839,
                "label": "Maximum Power Voltage (Vmp)",
                "value": "41.96V"
            }
        ],
        "documents": [
            {
                "id": 124,
                "description": "Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/Longi-LR5-72HPH-530-550M-Datasheet"
            }
        ],
        "images": [
            {
                "id": 167,
                "url": "https://www.solarcentral.co.za/images/LR5-72HPH-550M-01.png"
            },
            {
                "id": 166,
                "url": "https://www.solarcentral.co.za/images/LR5-72HPH-550M.png"
            },
            {
                "id": 168,
                "url": "https://www.solarcentral.co.za/images/LR5-72HPH-550M-02.png"
            }
        ],
        "distributors": [
            {
                "id": 103,
                "distributor": "GC Solar",
                "distributorClient": "za.co.visualage.inventory.distributor.GCSolarDistributorClient",
                "refreshUrl": "https://onlineshop.gcsolar.co.za/product/longi-solar-550w-mono/",
                "code": "LR5-72HPH-550M",
                "sku": "LR5-72HPH-550M",
                "inventoryStatus": "INSTOCK",
                "cost": 1792.8,
                "markup": 0.1,
                "retail": 1992
            }
        ],
        "ratings": [
            {
                "id": 162,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 161,
                "type": "Features",
                "rating": 4
            },
            {
                "id": 164,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 163,
                "type": "Durability",
                "rating": 4
            }
        ]
    },
    {
        "id": 82,
        "uid": "cf7373e6-2b2e-464a-9563-bd0ee6c28176",
        "code": "DEYE-8K-SG05LP1-EU-SM2",
        "name": "8kW Hybrid Inverter",
        "longName": "Deye 8kW Hybrid Inverter (2025 Model)",
        "brand": "Deye",
        "image": "https://www.solarcentral.co.za/images/DEYE-8K-SG05LP1-EU-SM2.png",
        "price": 26299,
        "discount": null,
        "category": "Inverters",
        "subCategory": "Residential, Hybrid",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "qty": null,
        "rating": 4.6,
        "reviews": 1,
        "title": "Solar Central | Products | Deye 8kW Hybrid Inverter",
        "keywords": "Deye 8kW Hybrid Inverter South Africa, Deye 8kW Inverter 2025 Model, Solar Inverter South Africa, Hybrid Inverter South Africa, Deye 8kW Inverter Price SA, Best Solar Inverter South Africa, Deye Hybrid Inverter Load Shedding, 8kW Solar Inverter South Africa, Deye 8kW Inverter Installation SA, Deye 8kW Hybrid Inverter Review, Solar Power Solutions South Africa, Deye Inverter 2025 South Africa, Deye 8kW Battery Compatibility, Off-Grid Inverter South Africa, Deye 8kW Inverter Warranty SA, Solar Energy Inverter South Africa, Deye 8kW Parallel Inverter SA, Deye Inverter Smart Monitoring, Deye 8kW Inverter Efficiency, Buy Deye 8kW Inverter South Africa",
        "description": "Deye 8kW Hybrid Inverter (2025 Model)",
        "root": "deye-8kw-hybrid-inverter",
        "visible": true,
        "highlights": [
            {
                "id": 327,
                "label": "Maximum Efficiency (%)",
                "value": "97.6",
                "deleted": null
            },
            {
                "id": 330,
                "label": "Battery Compatibility",
                "value": "Lithium-ion & Lead-acid",
                "deleted": null
            },
            {
                "id": 328,
                "label": "PV Input Power (kW)",
                "value": "12.8",
                "deleted": null
            },
            {
                "id": 329,
                "label": "Transfer Time (ms)",
                "value": "4-5",
                "deleted": null
            }
        ],
        "overviews": [
            {
                "id": 102,
                "html": "<h4>Product Description</h4><p>Power your home or business with the Deye 8kW Hybrid Inverter (2025 Model), a cutting-edge solution designed for South Africa’s energy needs. Engineered to combat load shedding and maximise solar efficiency, this inverter delivers reliable, scalable, and smart energy management for both on-grid and off-grid applications.</p><p>Boasting a<strong>rated AC output of 8000W (with a peak of 8800W)</strong>, this hybrid inverter supports a maximum PV input of 12.8kW through dual MPPT trackers, each handling up to 26A, ensuring optimal solar energy capture with an impressive 97.6% maximum efficiency. Compatible with both lithium-ion and lead-acid batteries (40-60V range), it offers a robust 210A max charging/discharging current, making it ideal for powering high-demand households or small businesses during outage.</p><p>The Deye 8kW Hybrid Inverter excels in versatility, supporting<strong>parallel operation of up to 16 units</strong>for scalable energy systems. Its 4-5ms transfer time ensures seamless switching between grid and off-grid modes, providing uninterrupted power during load shedding. The inverter also supports AC coupling for retrofitting existing solar systems and integrates with diesel generators for added reliability in remote setups.</p><p>Smart energy management is at your fingertips with the colorful LCD touchscreen and advanced monitoring platform. Remotely control and monitor your system, perform firmware updates, or activate shutdowns via the inverter’s WiFi-enabled smart features. The IP65-rated enclosure ensures durability in South Africa’s diverse climates, while compliance with standards like IEC61727 and NRS097 guarantees safety and grid compatibility.</p><p>Whether you’re reducing electricity costs, preparing for load shedding, or building an off-grid solar system, the Deye 8kW Hybrid Inverter delivers unmatched performance. Its<strong>5-year standard warranty</strong>(extendable based on supplier terms) offers peace of mind, while the ability to handle string voltages up to 500VDC and multiple battery types ensures flexibility for any setup. Installation is straightforward, with comprehensive support available through local suppliers.</p><p>Embrace energy independence with the Deye 8kW Hybrid Inverter (2025 Model), the perfect blend of efficiency, reliability, and innovation for South African homes and businesses. Order now to secure your power future with a trusted, high-performance solar solution.</p><ul class=\"disc\"><li>Rated AC Output: 8000W</li><li>Max PV Input: 12.8kW</li><li>Efficiency: 97.6%</li><li>Battery Voltage: 40-60V</li><li>Transfer Time: 4-5ms</li><li>Parallel Capacity: Up to 16 units</li><li>Warranty: 5 years (standard)</li></ul>",
                "deleted": null
            }
        ],
        "specifications": [
            {
                "id": 845,
                "label": "Maximum AC Output Power",
                "value": "8000W",
                "deleted": null
            },
            {
                "id": 852,
                "label": "PV Input Current per Tracker",
                "value": "26",
                "deleted": null
            },
            {
                "id": 846,
                "label": "Maximum PV Input Power",
                "value": "12800W",
                "deleted": null
            },
            {
                "id": 853,
                "label": "Parallel Operation",
                "value": "16",
                "deleted": null
            },
            {
                "id": 849,
                "label": "Battery Voltage Range",
                "value": "40-60V",
                "deleted": null
            },
            {
                "id": 848,
                "label": "Battery Type",
                "value": "Lead-acid or Lithium-ion",
                "deleted": null
            },
            {
                "id": 844,
                "label": "Power Output",
                "value": "8kW",
                "deleted": null
            },
            {
                "id": 851,
                "label": "Number of MPPT Trackers",
                "value": "2",
                "deleted": null
            },
            {
                "id": 847,
                "label": "Maximum Efficiency",
                "value": "97.6%",
                "deleted": null
            },
            {
                "id": 850,
                "label": "Maximum Charging/Discharging Current",
                "value": "210A",
                "deleted": null
            }
        ],
        "documents": [
            {
                "id": 125,
                "description": "Datasheet",
                "url": "https://www.solarcentral.co.za/pdf/datasheet_sun-7-10k-sg05lp1-eu-sm2.pdf",
                "deleted": null
            },
            {
                "id": 126,
                "description": "Manual",
                "url": "https://www.solarcentral.co.za/pdf/instructions_sun-3.6-8k-sg05lp1-eu-sm2.pdf",
                "deleted": null
            }
        ],
        "images": [
            {
                "id": 169,
                "url": "https://www.solarcentral.co.za/images/DEYE-8K-SG05LP1-EU-SM2.png",
                "deleted": null
            },
            {
                "id": 170,
                "url": "https://www.solarcentral.co.za/images/DEYE-8K-SG05LP1-EU-SM2-01.png",
                "deleted": null
            },
            {
                "id": 171,
                "url": "https://www.solarcentral.co.za/images/DEYE-8K-SG05LP1-EU-SM2-02.png",
                "deleted": null
            }
        ],
        "distributors": [
            {
                "id": 104,
                "distributor": "SolarWay",
                "distributorClient": "za.co.visualage.inventory.distributor.SolarWayDistributorClient",
                "refreshUrl": "https://www.solarwaysuppliers.co.za/index.php/product/8kw-deye-hybrid-inverter-2025-model",
                "code": "DEYE-8K-SG05LP1-EU-SM2",
                "sku": "SUN-8K-SG05LP1-EU-SM2",
                "inventoryStatus": "INSTOCK",
                "cost": 2392,
                "markup": 0.1,
                "retail": 26299,
                "lastRefreshDate": null,
                "deleted": null
            }
        ],
        "ratings": [
            {
                "id": 165,
                "type": "Features",
                "rating": 4,
                "deleted": null
            },
            {
                "id": 166,
                "type": "Warranty",
                "rating": 4,
                "deleted": null
            },
            {
                "id": 167,
                "type": "Durability",
                "rating": 4,
                "deleted": null
            },
            {
                "id": 168,
                "type": "Ease of Use",
                "rating": 4,
                "deleted": null
            }
        ],
    },
    {
        "id": 86,
        "uid": "0427eb56-a264-4d3f-b36f-da79a366dcaa",
        "code": "VOL-5KW-SGE-1",
        "name": "Volta 5.12kWh Lithium-Ion Battery",
        "longName": "Volta Stage 1 Lithium-Ion 5.12kWh Lithium-Ion Battery (51.2V 100Ah)",
        "brand": "Volta",
        "image": "https://www.solarcentral.co.za/images/VOL-5KW-SGE-1.png",
        "price": 22250,
        "category": "Batteries",
        "subCategory": "Lithium-Ion",
        "inventory": 0,
        "inventoryStatus": "INSTOCK",
        "rating": 4.6,
        "reviews": 1,
        "title": "Solar Central | Products | Volta 5.12kWh Lithium-Ion Battery",
        "keywords": "Volta, 5kW, Lithium-Ion, 48v, Solar Battery, Residential, South Africa",
        "description": "Volta Stage 1 Lithium-Ion 5.12kWh Lithium-Ion Battery (51.2V 100Ah)",
        "root": "volta-5kw-lithium-ion-100ah",
        "visible": true,
        "highlights": [
            {
                "id": 320,
                "label": "Device",
                "value": "Solar Battery"
            },
            {
                "id": 321,
                "label": "Type",
                "value": "Lithium-Ion"
            },
            {
                "id": 322,
                "label": "Power",
                "value": "5.12kWh"
            }
        ],
        "overviews": [
            {
                "id": 100,
                "html": "<h4>Product Description</h4><div><br></div><div><div>The Volta Stage 1 Lithium-Ion 5.12kWh Battery, operating at 51.2V with a 100Ah capacity, is a cutting-edge energy storage solution tailored for residential, commercial, and off-grid solar applications. Built with Lithium Iron Phosphate (LiFePO4) technology, this battery delivers exceptional safety, efficiency, and durability compared to traditional lead-acid alternatives. With a nominal energy capacity of 5.12kWh, it can power an 8800W AC load for approximately one hour or sustain a 1kW household load for over 10 hours. Its robust design ensures a cycle life exceeding 6000 cycles at 80% Depth of Discharge, with a projected lifespan of 10-15 years, making it a reliable choice for long-term energy needs.</div><div><br></div><h4>Scalable and Modular Design:&#160;</h4><div>Designed for flexibility, the Volta Stage 1 supports scalability by allowing up to eight units to be connected in parallel, enabling a total capacity of 40kWh. This modular approach accommodates evolving energy demands, whether for expanding solar installations or enhancing backup power systems. The battery’s compact form factor supports both wall-mount and floor-stand configurations, optimising space utilisation. Top-mounted connectors simplify installation, ensuring seamless integration into various setups without compromising accessibility or safety.</div><div><br></div><h4>Intelligent Energy Management:&#160;</h4><div>The battery incorporates an advanced Battery Management System (BMS) that optimises performance and safety. This intelligent system monitors and protects against overcharge, over-discharge, and short-circuiting, ensuring operational reliability. Compatible with leading inverter brands such as Deye, Sunsynk, Victron, and SMA, the Volta Stage 1 supports RS485, RS232, and CAN communication protocols for real-time energy monitoring and management. This ensures efficient energy distribution and maximises the system’s overall performance in diverse applications.</div><div><br></div><h4>Safety and Environmental Resilience:&#160;</h4><div>Safety is paramount with the Volta Stage 1, thanks to its LiFePO4 chemistry, which offers thermal and chemical stability to minimise risks of fire or explosion. The battery operates reliably across a wide temperature range, from -20°C to +65°C for discharge and 0°C to +65°C for charging, with IP20 ingress protection. This resilience makes it suitable for various environmental conditions, ensuring consistent performance in demanding settings.</div><div><br></div><h4>Applications and Installation:&#160;</h4><div>Ideal for solar energy storage, backup power, and hybrid systems, the Volta Stage 1 promotes energy independence and sustainability. Professional installation by a certified electrician is required to comply with local regulations and maintain the 10-year cell warranty and 5-year BMS warranty, ensuring long-term reliability and peace of mind.</div></div>"
            }
        ],
        "specifications": [
            {
                "id": 829,
                "label": "Standard Charge Voltage",
                "value": "56VDC"
            },
            {
                "id": 823,
                "label": "Nominal Energy",
                "value": "5.12kWh"
            },
            {
                "id": 828,
                "label": "Maximum Discharge Current",
                "value": "100A"
            },
            {
                "id": 830,
                "label": "Discharge Cut-Off Voltage",
                "value": "44.8VDC"
            },
            {
                "id": 824,
                "label": "Capacity",
                "value": "5.12kWh"
            },
            {
                "id": 831,
                "label": "Weight",
                "value": "45.2kg"
            },
            {
                "id": 833,
                "label": "Scalability",
                "value": "8"
            },
            {
                "id": 826,
                "label": "Cell Type",
                "value": "Lithium Iron Phosphate (LiFePO4)"
            },
            {
                "id": 827,
                "label": "Cycle Life",
                "value": "Over 6000 cycles at 80% Depth of Discharge (25°C)"
            },
            {
                "id": 832,
                "label": "Operating Temperature",
                "value": "Charge: 0°C to +65°C; Discharge: -20°C to +65°C"
            },
            {
                "id": 825,
                "label": "Nominal Voltage",
                "value": "51.2VDC"
            }
        ],
        "documents": [
            {
                "id": 123,
                "description": "Specification Sheet",
                "url": "https://www.solarcentral.co.za/pdf/Volta-5.12KwH-Lithium-Ion.pdf"
            }
        ],
        "images": [
            {
                "id": 165,
                "url": "https://www.solarcentral.co.za/images/VOL-5KW-SGE-1-01.png"
            },
            {
                "id": 164,
                "url": "https://www.solarcentral.co.za/images/VOL-5KW-SGE-1.png"
            }
        ],
        "distributors": [
            {
                "id": 102,
                "distributor": "Banqo Power",
                "distributorClient": "za.co.visualage.inventory.distributor.BanqoPowerDistributorClient",
                "refreshUrl": "https://www.banqopower.com/online-store/Volta-Stage-1-Lithium-Ion-5-12KwH-Lithium-Ion-Battery-51-2V-100Ah-p603451872",
                "code": "VOL-5KW-SGE-1",
                "sku": "VOL-5KW-SGE-1",
                "inventoryStatus": "INSTOCK",
                "cost": 20599,
                "markup": 0.08,
                "retail": 22250
            }
        ],
        "ratings": [
            {
                "id": 159,
                "type": "Durability",
                "rating": 4
            },
            {
                "id": 160,
                "type": "Ease of Use",
                "rating": 4
            },
            {
                "id": 158,
                "type": "Warranty",
                "rating": 4
            },
            {
                "id": 157,
                "type": "Features",
                "rating": 4
            }
        ]
    }
]